// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:35:41.819Z
// Property: The Greens of Bedford (ID: 6767906449165634)
// Collections: 18 amenities, 4 floorplans (live), 35 photos, 65 POIs, 3 reviews, 1 virtual tours, 7 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165634",
  "property_external_id": "4s89f5k",
  "property_zillow_url": "https://www.zillow.com/homedetails/6508-S-106th-East-Pl-Tulsa-OK-74133/2126894217_zpid/",
  "property_apartments_url": "https://www.apartments.com/the-greens-of-bedford-tulsa-ok/4s89f5k/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Greens+of+Bedford/data=!4m2!3m1!1s0x0:0x3cd6b59ccd152e96?sa=X&ved=2ahUKEwjtorSJgb2SAxVE5MkDHfn1HHoQ_BJ6BAgVEAA&hl=en&gl=us",
  "property_linkedin_url": "https://www.linkedin.com/in/greens-of-bedford-apartments-94500071",
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-greens-of-bedford",
  "property_name": "The Greens of Bedford",
  "property_website_url": "https://www.caseusa.com/apartments/ok/tulsa/the-greens-of-bedford/",
  "property_domain": null,
  "property_address": "6508-6513 S 106th East Pl",
  "property_full_address": "6508 South 106th East Place, Tulsa, OK, 74133",
  "property_address_1": "6508 South 106th East Place",
  "property_address_2": null,
  "property_address_city": "Tulsa",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "74133",
  "property_address_country": "US",
  "property_address_county": "Tulsa County",
  "property_neighborhood_address": "South Tulsa",
  "property_address_latitude": "36.0694",
  "property_address_longitude": "-95.8576",
  "property_email": "greensofbedford@caseusa.com",
  "property_phone": "(539) 995-5864",
  "property_call_tracking_phone": "855-459-2410",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At The Greens of Bedford in Tulsa, Oklahoma, luxury living meets comfort in our thoughtfully designed one, two, and three-bedroom apartments. Enjoy an array of amenities, including a refreshing pool, state-of-the-art fitness center, and serene walking trails. Your perfect home awaits—browse availability or schedule your tour today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to The Greens of Bedford, where comfort meets convenience in the heart of Tulsa, Oklahoma. Our beautifully designed apartment community offers an array of spacious floor plans, featuring one, two, and three-bedroom layouts to cater to your unique lifestyle. Each apartment is equipped with modern amenities, including a washer and dryer, air conditioning, and high-speed internet access, ensuring you have everything you need to feel right at home.\n\nEmbrace a life of leisure with our exceptional on-site amenities. Dive into relaxation at our sparkling pool, stay active in our state-of-the-art fitness center, or enjoy quality family time at the playground. The vibrant clubhouse is perfect for social gatherings, while our business center offers a quiet space to work from home. For pet owners, our dedicated pet play area provides a safe and fun environment for your furry friends.\n\nTake advantage of our beautiful outdoor spaces, including walking and biking trails, picnic areas, and grill stations, perfect for enjoying sunny Oklahoma days. With maintenance and property management on-site, you can rest easy knowing you’re well taken care of.\n\nExperience a smoke-free environment with features such as walk-in closets, bay windows, and extra storage space that make living here both comfortable and affordable. With a variety of options available, finding your new home has never been easier.\n\nDiscover The Greens of Bedford today—your oasis awaits! Browse our availability or schedule a tour to experience the community firsthand. Let us welcome you to your new home!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb4a-92a4-72f3-9753-9694c7cd3e1f.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of a multifamily property with multiple buildings, parking lots, and surrounding greenery.",
    "public_id": "019cfb4a-92a4-72f3-9753-9694c7cd3e1f",
    "storage_key": "property/6767906449165634/019cfb4a-92a4-72f3-9753-9694c7cd3e1f.webp",
    "width": 2048,
    "height": 1365
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "384",
  "property_year_built": "1984",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.61458333333334",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Contact Leasing Office for details",
  "property_pet_policy_description": "Pets Welcome - Contact Leasing Office for details",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://greensofbedfordapartmentstulsa.securecafe.com/onlineleasing/the-greens-of-bedford/floorplans.aspx",
  "property_resident_portal_url": "https://greensofbedfordapartmentstulsa.securecafe.com/residentservices/the-greens-of-bedford/userlogin.aspx",
  "property_apply_now_url": "https://greensofbedfordapartmentstulsa.securecafe.com/onlineleasing/the-greens-of-bedford/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-9f19-7647-9092-a7aa72a2ecb4.webp",
  "property_primary_logo_media": {
    "alt_text": "The Greens of Bedford logo",
    "public_id": "019cfb49-9f19-7647-9092-a7aa72a2ecb4",
    "storage_key": "property/6767906449165634/019cfb49-9f19-7647-9092-a7aa72a2ecb4.webp",
    "width": 251,
    "height": 176
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb4a-8859-7693-bf90-71a0292accd8.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb4a-8859-7693-bf90-71a0292accd8",
    "storage_key": "property/6767906449165634/019cfb4a-8859-7693-bf90-71a0292accd8.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb4a-a8cf-75b8-a6aa-994c637cd559.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Greens of Bedford logo",
    "public_id": "019cfb4a-a8cf-75b8-a6aa-994c637cd559",
    "storage_key": "property/6767906449165634/019cfb4a-a8cf-75b8-a6aa-994c637cd559.webp",
    "width": 251,
    "height": 176
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb4a-b0d1-776a-90e7-f78cefb8903b.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Greens of Bedford logo",
    "public_id": "019cfb4a-b0d1-776a-90e7-f78cefb8903b",
    "storage_key": "property/6767906449165634/019cfb4a-b0d1-776a-90e7-f78cefb8903b.webp",
    "width": 251,
    "height": 176
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#324d58",
  "property_secondary_color": "#676865",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#99ba3c",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "700 - 1200",
  "property_sqft_min": "700",
  "property_sqft_max": "1200",
  "property_price_range": "949 - 1369",
  "property_price_min": "949",
  "property_price_max": "1369",
  "property_available_units": 10,
  "property_facebook_url": "https://www.facebook.com/GOBAptsTulsa/videos/",
  "property_instagram_url": "https://www.instagram.com/thegreensofbedfordapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJycPvwieNtocRli4VzZy11jw",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=Tulsa%2C+OK",
  "property_tiktok_url": "https://www.tiktok.com/@greensofbedford",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Greens Of Bedford",
  "property_home_romance_title": "Embrace a New Chapter in Your Dream Home Today",
  "property_home_amenities_blurb": "Welcome to The Greens of Bedford in Tulsa, Oklahoma, where comfort meets convenience. Choose from our thoughtfully designed one, two, or three-bedroom apartments, complete with modern amenities like a sparkling pool, fitness center, and playful pet area. Unwind at the clubhouse or take a stroll along scenic walking trails—home awaits!",
  "property_home_floorplans_blurb": "Welcome to The Greens of Bedford in Tulsa, Oklahoma, where comfort meets style. With versatile one, two, and three-bedroom floor plans, you'll find the ideal space to make your own. Browse our available apartment homes today and envision your new lifestyle in a community designed for modern living.",
  "property_home_gallery_blurb": "At The Greens of Bedford in Tulsa, comfort meets convenience. Choose from our spacious one, two, or three-bedroom layouts, each designed for modern living. Enjoy amenities like a sparkling pool, fitness center, and pet-friendly play areas. Picture yourself relaxing in your new home today—life here is waiting!",
  "property_home_neighborhood_blurb": "Nestled in the heart of Tulsa, The Greens of Bedford offers spacious one, two, and three-bedroom apartments with access to vibrant local culture. Dive into the neighborhood's hidden gems and popular hotspots—enrich your lifestyle with dining, shopping, and recreational treasures just steps from home. Explore your new community today!",
  "property_home_reviews_blurb": "Welcome to The Greens of Bedford, where residents celebrate a life filled with kindness and support. “The management and maintenance are kind and helpful,” creating a welcoming environment in our vibrant Tulsa community. Join us and experience top-notch service and a peaceful atmosphere that makes you feel right at home!",
  "property_neighborhood_blurb": "Nestled in the heart of Tulsa, The Greens of Bedford offers a vibrant community surrounded by esteemed educational institutions, including Oral Roberts University and the University of Tulsa. Families will appreciate the proximity to Union High School and Thomas Jefferson Elementary. See what's around our community and dive into local favorites!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At The Greens of Bedford in Tulsa, experience a harmonious blend of comfort and convenience. Choose from beautifully designed one, two, and three-bedroom apartments, all featuring high-speed internet and modern kitchens. Enjoy our refreshing pool, cozy clubhouse, and lush walking trails—your perfect retreat awaits. Explore our amazing community amenities today!",
  "property_applynow_blurb": "Welcome to The Greens of Bedford in Tulsa, Oklahoma, where comfort meets convenience. Choose from spacious one, two, or three-bedroom floor plans, all featuring modern amenities like a refreshing pool, a state-of-the-art fitness center, and pet-friendly spaces. Embrace a vibrant lifestyle; lease your dream home online today!",
  "property_contactus_blurb": "At The Greens of Bedford in Tulsa, Oklahoma, our thoughtfully designed one, two, and three-bedroom floor plans cater to every lifestyle. Whether you seek spacious living or cozy comfort, we have the perfect space for you. Have questions? Contact our leasing team today to find your ideal home!",
  "property_faqs_blurb": "At The Greens of Bedford in Tulsa, Oklahoma, our diverse floor plans, including one, two, and three-bedroom options, are designed to suit every lifestyle. Have questions? Our FAQs page offers helpful insights to guide your journey. Uncover the answers you need for a seamless living experience!",
  "property_floorplans_blurb": "At The Greens of Bedford in Tulsa, Oklahoma, you'll find thoughtfully designed floor plans tailored for every lifestyle. Whether you need a cozy one-bedroom, a spacious two-bedroom, or a family-friendly three-bedroom, our diverse options cater to your unique needs. Browse our available apartment homes and find your perfect fit today!",
  "property_gallery_blurb": "Step into The Greens of Bedford, where stylish floor plans meet unparalleled amenities. Picture sun-soaked afternoons by the sparkling pool, invigorating workouts in the fitness center, and cozy evenings by the fireplace. Envision life among the lush walking trails and modern finishes. Welcoming pet-friendly spaces await you in Tulsa, Oklahoma!",
  "property_interactivemap_blurb": "Welcome to The Greens of Bedford, where comfort meets convenience in Tulsa, Oklahoma. Our varied floor plans—one, two, and three-bedroom apartments—offer modern amenities like a refreshing pool, fitness center, and serene walking trails. Use our interactive community map to find the perfect space for your lifestyle!",
  "property_pets_blurb": "At The Greens of Bedford in Tulsa, OK, your furry friends are part of the family! Our welcoming community embraces pets, ensuring everyone finds comfort in their new home. Reach out to the leasing office for details, and let your four-legged companions enjoy the green spaces and vibrant atmosphere we offer.",
  "property_referafriend_blurb": "At The Greens of Bedford in Tulsa, we offer spacious one, two, and three-bedroom floor plans designed for comfort and style. Elevate your living experience and share the joy—refer a friend to join our vibrant community today! Great friends make great neighbors, so let's grow together!",
  "property_residentaccess_blurb": "At The Greens of Bedford in Tulsa, Oklahoma, our diverse floor plans cater to every lifestyle—choose from one, two, or even three-bedroom apartments tailored for comfort. Ready to take control? Access your resident portal to pay rent, schedule maintenance, and simplify your living experience today!",
  "property_reviews_blurb": "At The Greens of Bedford in Tulsa, residents relish the warmth of a truly supportive community. With heartfelt acclaim for our “kind and helpful” staff, it’s no wonder our residents feel at home. Experience a peaceful atmosphere and attentive management that prioritizes your comfort—see what our residents have to say!",
  "property_created_at": "1753982394418",
  "property_scheduletour_blurb": "At The Greens of Bedford in Tulsa, Oklahoma, our thoughtfully designed one, two, and three-bedroom floor plans cater to your lifestyle. Step into a vibrant community where comfort meets convenience. Curious about resident experiences? Schedule a tour and see why so many love calling us home!",
  "property_thankyou_blurb": "Thank you for reaching out to The Greens of Bedford in Tulsa! Our diverse floor plans—featuring one, two, and three-bedroom options—offer something for everyone. A member of our friendly team will be in touch soon to help you find your perfect new home in our welcoming community!",
  "property_virtualtours_blurb": "Step into your future at The Greens Of Bedford in Tulsa, Oklahoma, where spacious living meets modern elegance. From cozy one-bedroom retreats to expansive three-bedroom homes, our diverse floor plans cater to every lifestyle. Experience the charm of our community—take a virtual tour today and envision your new home!",
  "property_copyright": "2025 All Rights Reserved. The Greens Of Bedford",
  "property_seo_title_home": "The Greens Of Bedford | Apartments in Tulsa, Oklahoma",
  "property_seo_description_home": "Experience comfort and style at The Greens of Bedford in Tulsa! Enjoy spacious floor plans, top-notch amenities, and a vibrant community. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Tulsa, Oklahoma",
  "property_seo_description_floorplans": "Find your ideal home at The Greens Of Bedford in Tulsa! Choose from one, two, or three-bedroom floor plans and embrace a lifestyle of comfort and convenience.",
  "property_seo_title_amenities": "Amenities | Tulsa, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Experience comfort at The Greens of Bedford in Tulsa, OK! Dive into our vibrant amenities like a sparkling pool, fitness center, and cozy clubhouse. Live your best life!",
  "property_seo_title_gallery": "Gallery | Apartments in Tulsa, Oklahoma",
  "property_seo_description_gallery": "\"Picture life at The Greens Of Bedford in Tulsa! Enjoy stunning floor plans, top-tier amenities, and vibrant outdoor spaces—all tailored for your perfect home.\"",
  "property_seo_title_virtualtours": "Virtual Tours | The Greens Of Bedford Apartments",
  "property_seo_description_virtualtours": "Experience The Greens of Bedford in Tulsa! Dive into our stunning virtual tour and find the perfect one, two, or three-bedroom apartment tailored for you.",
  "property_seo_title_interactivemap": "Interactive Map | The Greens Of Bedford Apartments",
  "property_seo_description_interactivemap": "Uncover your ideal apartment at The Greens of Bedford in Tulsa! Enjoy spacious floor plans, top-notch amenities, and a vibrant community. Start your search now!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Tulsa, Oklahoma",
  "property_seo_description_neighborhood": "Uncover the charm of Tulsa at The Greens of Bedford. From cozy one-bedrooms to spacious three-bedrooms, see local favorites and nearby gems today!",
  "property_seo_title_contact": "Contact Us | The Greens Of Bedford",
  "property_seo_description_contact": "Reach out to The Greens Of Bedford in Tulsa! Our leasing team is ready to help you choose from our stunning one, two, or three-bedroom floor plans.",
  "property_seo_title_faqs": "FAQs | Apartments in Tulsa, Oklahoma",
  "property_seo_description_faqs": "Find your perfect home at The Greens Of Bedford in Tulsa! From spacious floor plans to top-notch amenities, our FAQs cover everything you need to know.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Tulsa, Oklahoma",
  "property_seo_description_reviews": "Join the vibrant community at The Greens of Bedford in Tulsa! Read resident reviews and see why our spacious apartments and superb amenities truly stand out.",
  "property_seo_title_applynow": "Apply Now | Apartments in Tulsa, Oklahoma",
  "property_seo_description_applynow": "Welcome to The Greens Of Bedford in Tulsa! Choose from spacious one to three-bedroom floor plans, and enjoy top-notch amenities. Your new home awaits—apply now!",
  "property_seo_title_residentaccess": "Resident Access | The Greens Of Bedford",
  "property_seo_description_residentaccess": "Seamlessly connect to your resident portal at The Greens Of Bedford. Manage rent, maintenance, and community life from the comfort of home in Tulsa!",
  "property_seo_title_referafriend": "Refer A Friend | The Greens Of Bedford",
  "property_seo_description_referafriend": "Refer a friend to The Greens of Bedford in Tulsa! Great friends make great neighbors—share the joy of vibrant living today! Enjoy exclusive perks together!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Greens Of Bedford",
  "property_seo_description_scheduletour": "Experience vibrant living at The Greens of Bedford! Schedule a tour today and envision your new home in Tulsa's charming community. Life awaits!",
  "property_seo_title_privacy": "Privacy Policy | The Greens Of Bedford",
  "property_seo_description_privacy": "Your privacy matters at The Greens Of Bedford in Tulsa. Read our policy to learn how we protect your information while you enjoy our vibrant community.",
  "property_seo_title_accessibility": "Website Accessibility | The Greens Of Bedford",
  "property_seo_description_accessibility": "\"At The Greens of Bedford in Tulsa, we prioritize accessibility for all. Join us in creating an inclusive community where everyone feels at home.\"",
  "property_seo_title_sitemap": "Sitemap | The Greens Of Bedford",
  "property_seo_description_sitemap": "Uncover your ideal living at The Greens of Bedford in Tulsa. Check out our sitemap to navigate your journey towards a vibrant community and your next home!",
  "property_seo_title_thankyou": "Thank You | The Greens Of Bedford",
  "property_seo_description_thankyou": "Thank you for reaching out to The Greens of Bedford! Your journey to a vibrant Tulsa community starts here. We'll be in touch soon to assist you.",
  "property_seo_title_pets": "Pet Policy | Apartments in Tulsa, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865951708",
  "amenities": [
    {
      "id": "ec_7efbe1d60288d9f3f719fb7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "yardi",
      "external_id": "127397290",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a144c59b441fae21c89e6126",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "yardi",
      "external_id": "127397293",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_835fb920e4c1590afec19248",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "yardi",
      "external_id": "127397294",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_402c7d5d6f3f536bca1d61e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "yardi",
      "external_id": "127397295",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d22131f0c8f3f0e0d26f8cab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "yardi",
      "external_id": "127397296",
      "title": "Availability 24 Hours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b3f331bf5cfd231f4a082fd6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "yardi",
      "external_id": "127397298",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2c4fc09033fb7e357402e0d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "yardi",
      "external_id": "127397299",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_daabe758a045f11e712e4919",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "yardi",
      "external_id": "128042535",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_52235e4ba4f2a538c3102ba8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "yardi",
      "external_id": "128017294",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_42b4a0d12f229c9c31aaabaf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "yardi",
      "external_id": "127398753",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e4ff7c8d8f09d9f9c7382004",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "yardi",
      "external_id": "127398754",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e7d75d2b16649371b63e6429",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "yardi",
      "external_id": "127398755",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1593731ad7bc5e5464d5f785",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "yardi",
      "external_id": "127398756",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f9b7d249d912691d1b8081bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "yardi",
      "external_id": "127398757",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a4783e226033d31c0bdf31f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "yardi",
      "external_id": "127398758",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fae19db738536c87929f1c21",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "yardi",
      "external_id": "127398759",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2a19b36def3e5c8815d8bea1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "yardi",
      "external_id": "127398760",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_96a144eaeb7cdaad55571a3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "yardi",
      "external_id": "127398761",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_bfef229b-822c-4362-8e80-67c81d7f9298",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c5-0331-72fb-aed6-a636573da744.webp",
      "image_media": {
        "alt_text": "Sidewalk path between brick apartment buildings with green grass and trees.",
        "public_id": "01a015c5-0331-72fb-aed6-a636573da744",
        "storage_key": "property/6767906449165634/01a015c5-0331-72fb-aed6-a636573da744.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Walk through the beautifully landscaped grounds of our community, with a clear path winding between charming brick apartment buildings, surrounded by lush green grass and mature trees.",
      "link": "",
      "alt_text": "Sidewalk path between brick apartment buildings with green grass and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d8c972c7-06c6-4802-89c5-1353f00ba03f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-fd0e-71aa-ba09-2d6fe32073bf.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with brick facade and manicured lawn.",
        "public_id": "01a015c4-fd0e-71aa-ba09-2d6fe32073bf",
        "storage_key": "property/6767906449165634/01a015c4-fd0e-71aa-ba09-2d6fe32073bf.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Charming apartment building exterior featuring a classic brick facade, well-maintained landscaping, and spacious green lawns.",
      "link": "",
      "alt_text": "Exterior of apartment building with brick facade and manicured lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7e9216fc-7f59-4994-85da-8ce9570c1307",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-f7e7-77e8-a55e-2e4537c169ff.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, green accent pillows, a walk-in closet, and artwork.",
        "public_id": "01a015c4-f7e7-77e8-a55e-2e4537c169ff",
        "storage_key": "property/6767906449165634/01a015c4-f7e7-77e8-a55e-2e4537c169ff.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in comfort in our beautifully appointed bedrooms, featuring ample closet space and stylish decor.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, green accent pillows, a walk-in closet, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bedc1208-3cb6-442c-94ad-edb7e5664d6e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-f318-71e9-b683-5030cc51c615.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, wooden nightstand with a lamp, and two windows.",
        "public_id": "01a015c4-f318-71e9-b683-5030cc51c615",
        "storage_key": "property/6767906449165634/01a015c4-f318-71e9-b683-5030cc51c615.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed bedroom, featuring a plush queen-size bed, elegant wooden furnishings, and ample natural light from two large windows.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, wooden nightstand with a lamp, and two windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ff2d8230-efc7-41ff-97a0-5d9006aad4ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-eee1-706e-89de-23544609c045.webp",
      "image_media": {
        "alt_text": "Bathroom with wood vanity, sink, toilet, and shower with white curtain.",
        "public_id": "01a015c4-eee1-706e-89de-23544609c045",
        "storage_key": "property/6767906449165634/01a015c4-eee1-706e-89de-23544609c045.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Bright and clean bathroom featuring a wood-grain vanity, a white sink and toilet, and a shower with a white curtain. Decorated with small potted plants and striped towels.",
      "link": "",
      "alt_text": "Bathroom with wood vanity, sink, toilet, and shower with white curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_83743218-ef42-467b-8721-a7f0d4a255c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-e6d9-7258-b0ff-0fc2c27088c7.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with carpet and shelves.",
        "public_id": "01a015c4-e6d9-7258-b0ff-0fc2c27088c7",
        "storage_key": "property/6767906449165634/01a015c4-e6d9-7258-b0ff-0fc2c27088c7.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with carpeted flooring and ample shelving space for storage.",
      "link": "",
      "alt_text": "Empty walk-in closet with carpet and shelves.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_05f44f0b-bdbe-4679-8802-51ecfce22b90",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-eeae-70ba-8261-41a69945096b.webp",
      "image_media": {
        "alt_text": "A staged bedroom with a queen-size bed, nightstand, and window.",
        "public_id": "01a015c4-eeae-70ba-8261-41a69945096b",
        "storage_key": "property/6767906449165634/01a015c4-eeae-70ba-8261-41a69945096b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy and inviting bedroom featuring a queen-size bed with crisp white linens, a wooden nightstand with a table lamp, and a large window allowing natural light.",
      "link": "",
      "alt_text": "A staged bedroom with a queen-size bed, nightstand, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2efa6a37-201a-4c61-ac68-8e2398707bbe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-e578-7648-86af-3994955aafa3.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, stainless steel sink, black refrigerator, and stovetop.",
        "public_id": "01a015c4-e578-7648-86af-3994955aafa3",
        "storage_key": "property/6767906449165634/01a015c4-e578-7648-86af-3994955aafa3.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring ample wood cabinetry, a double stainless steel sink, a black refrigerator, and a stovetop, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Kitchen with wood cabinets, stainless steel sink, black refrigerator, and stovetop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c47de23d-dc67-4668-8265-62993e32bba0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-e2f1-771c-a347-46d5517db5df.webp",
      "image_media": {
        "alt_text": "In-unit stacked washer and dryer.",
        "public_id": "01a015c4-e2f1-771c-a347-46d5517db5df",
        "storage_key": "property/6767906449165634/01a015c4-e2f1-771c-a347-46d5517db5df.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Enjoy the convenience of an in-unit stacked washer and dryer, making laundry day a breeze.",
      "link": "",
      "alt_text": "In-unit stacked washer and dryer.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1d85fd82-7c21-46da-8837-5960d6605a86",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-dc5b-76b1-9d71-ca13db99faea.webp",
      "image_media": {
        "alt_text": "Modern kitchen with wood cabinets, black appliances, granite countertops, and a double sink.",
        "public_id": "01a015c4-dc5b-76b1-9d71-ca13db99faea",
        "storage_key": "property/6767906449165634/01a015c4-dc5b-76b1-9d71-ca13db99faea.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Explore the inviting kitchen space, featuring ample wood cabinetry, modern black appliances including a microwave, and a convenient double sink. Perfect for preparing meals.",
      "link": "",
      "alt_text": "Modern kitchen with wood cabinets, black appliances, granite countertops, and a double sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_eef52466-d8cf-47d5-8db7-e2d7704963be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-d76a-71f4-8194-735b273d421c.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with wood cabinets, black appliances, and a ceiling fan.",
        "public_id": "01a015c4-d76a-71f4-8194-735b273d421c",
        "storage_key": "property/6767906449165634/01a015c4-d76a-71f4-8194-735b273d421c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Charming dining area adjacent to a well-equipped kitchen featuring wood cabinetry, black appliances, and a ceiling fan for comfort.",
      "link": "",
      "alt_text": "Dining area and kitchen with wood cabinets, black appliances, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_92f77406-74b4-4876-822c-a2e8cac57806",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-c4a8-7649-8655-0354cde7d507.webp",
      "image_media": {
        "alt_text": "Cozy living room with a green couch, glass coffee table, and a TV on a wooden media stand.",
        "public_id": "01a015c4-c4a8-7649-8655-0354cde7d507",
        "storage_key": "property/6767906449165634/01a015c4-c4a8-7649-8655-0354cde7d507.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in this inviting living room featuring a comfortable green sofa, a stylish glass coffee table, and a modern entertainment center with a flat-screen TV.",
      "link": "",
      "alt_text": "Cozy living room with a green couch, glass coffee table, and a TV on a wooden media stand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_503752e1-85a2-4926-b701-7a7884f60fef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-c3fa-74dc-97f6-edde1ca71adb.webp",
      "image_media": {
        "alt_text": "Spacious living room with a green sofa, coffee table, and large window.",
        "public_id": "01a015c4-c3fa-74dc-97f6-edde1ca71adb",
        "storage_key": "property/6767906449165634/01a015c4-c3fa-74dc-97f6-edde1ca71adb.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy a comfortable and stylish living space with ample natural light and modern furnishings. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Spacious living room with a green sofa, coffee table, and large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f62b800d-3d79-4c84-9d8f-bb812ccdf837",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-b1ef-759c-918b-0aca1e50dfe9.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "01a015c4-b1ef-759c-918b-0aca1e50dfe9",
        "storage_key": "property/6767906449165634/01a015c4-b1ef-759c-918b-0aca1e50dfe9.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and lush landscaping. The perfect place to relax and unwind.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9f551fc8-0d80-4acb-a202-2e94408a16f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-a645-74d8-aaeb-41174a7ada3d.webp",
      "image_media": {
        "alt_text": "Sparkling blue swimming pool with lounge chairs and tables, surrounded by apartment buildings.",
        "public_id": "01a015c4-a645-74d8-aaeb-41174a7ada3d",
        "storage_key": "property/6767906449165634/01a015c4-a645-74d8-aaeb-41174a7ada3d.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our outdoor swimming pool, complete with comfortable lounge chairs and tables for relaxation.",
      "link": "",
      "alt_text": "Sparkling blue swimming pool with lounge chairs and tables, surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d8e67d79-c6c2-4f87-bd4d-72ab9807ffec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-a5a6-7728-b3fc-6a002872cd1b.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, bedside table, and window.",
        "public_id": "01a015c4-a5a6-7728-b3fc-6a002872cd1b",
        "storage_key": "property/6767906449165634/01a015c4-a5a6-7728-b3fc-6a002872cd1b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom, featuring a plush queen-size bed, a stylish bedside table with a lamp, and a large window with blinds for natural light.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, bedside table, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7df16aa6-3821-4b7c-9d03-e42ddf5c3e8d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-a57f-763f-9409-4217dca71a7b.webp",
      "image_media": {
        "alt_text": "Playground with slide and apartment buildings in the background",
        "public_id": "01a015c4-a57f-763f-9409-4217dca71a7b",
        "storage_key": "property/6767906449165634/01a015c4-a57f-763f-9409-4217dca71a7b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, perfect for families. The property also features a swimming pool and ample parking.",
      "link": "",
      "alt_text": "Playground with slide and apartment buildings in the background",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_23676d6d-2666-4e71-ada3-f5e200e11594",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-a6a9-76ec-9910-93bb90506943.webp",
      "image_media": {
        "alt_text": "Bathroom with tub, toilet, and vanity.",
        "public_id": "01a015c4-a6a9-76ec-9910-93bb90506943",
        "storage_key": "property/6767906449165634/01a015c4-a6a9-76ec-9910-93bb90506943.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a bathtub with white tiled walls, a toilet, and a wooden vanity with a sink and mirror.",
      "link": "",
      "alt_text": "Bathroom with tub, toilet, and vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f12bb19b-4858-441b-a76f-1d34f8e8fe37",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-a538-731e-8415-b6443429f542.webp",
      "image_media": {
        "alt_text": "Modern kitchen with wood cabinets, black appliances, and granite countertops.",
        "public_id": "01a015c4-a538-731e-8415-b6443429f542",
        "storage_key": "property/6767906449165634/01a015c4-a538-731e-8415-b6443429f542.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Step into this charming apartment kitchen, featuring ample cabinet space, modern appliances, and stylish decor for a comfortable living experience.",
      "link": "",
      "alt_text": "Modern kitchen with wood cabinets, black appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a3723752-cc88-4b7e-8c91-e03bb4481ab8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-5d4b-73fd-bafb-a7e27c67eee9.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, and a door.",
        "public_id": "01a015c4-5d4b-73fd-bafb-a7e27c67eee9",
        "storage_key": "property/6767906449165634/01a015c4-5d4b-73fd-bafb-a7e27c67eee9.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious and well-lit bedroom featuring a queen-size bed with plush bedding, a rustic-style nightstand with a modern lamp, and a door leading outside.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstand, and a door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_74b88989-042b-4338-84eb-c44233abb09c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-4a71-7778-82d8-f25054368530.webp",
      "image_media": {
        "alt_text": "Living room with a large sofa, armchair, coffee table, and TV console.",
        "public_id": "01a015c4-4a71-7778-82d8-f25054368530",
        "storage_key": "property/6767906449165634/01a015c4-4a71-7778-82d8-f25054368530.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa, armchair, coffee table, and entertainment console. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with a large sofa, armchair, coffee table, and TV console.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a1c0588f-5c0b-4fd0-a551-894c8acfa0f4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-4ec4-72bc-8879-7c851b3ee165.webp",
      "image_media": {
        "alt_text": "Bathroom with a vanity, toilet, and bathtub with a shower curtain.",
        "public_id": "01a015c4-4ec4-72bc-8879-7c851b3ee165",
        "storage_key": "property/6767906449165634/01a015c4-4ec4-72bc-8879-7c851b3ee165.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A bright and functional bathroom featuring a wooden vanity with ample storage, a toilet, and a bathtub with a decorative shower curtain. Tile flooring and decorative wall art complete the space.",
      "link": "",
      "alt_text": "Bathroom with a vanity, toilet, and bathtub with a shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ea0db7a9-3e8c-4182-a2d9-971ea27db91f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-3c0d-773a-ad8a-f5ac56003766.webp",
      "image_media": {
        "alt_text": "Dining area with a round wooden table and four white chairs, abstract art on wall.",
        "public_id": "01a015c4-3c0d-773a-ad8a-f5ac56003766",
        "storage_key": "property/6767906449165634/01a015c4-3c0d-773a-ad8a-f5ac56003766.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy meals in this charming dining area, perfect for intimate gatherings. Features a round wooden table and seating for four.",
      "link": "",
      "alt_text": "Dining area with a round wooden table and four white chairs, abstract art on wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e2f8eb5b-8866-419b-b656-63540b26c3d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-3a76-74be-9849-44e7265a3d8f.webp",
      "image_media": {
        "alt_text": "Living and dining room with a sofa, coffee table, TV, and dining set.",
        "public_id": "01a015c4-3a76-74be-9849-44e7265a3d8f",
        "storage_key": "property/6767906449165634/01a015c4-3a76-74be-9849-44e7265a3d8f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living and dining area with modern furnishings, perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living and dining room with a sofa, coffee table, TV, and dining set.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9149058a-455c-4a6c-a21e-0a4c8cd8de70",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-3553-734b-be57-166cbdb7a33f.webp",
      "image_media": {
        "alt_text": "A fenced-in dog park with agility equipment, red tunnel, and benches.",
        "public_id": "01a015c4-3553-734b-be57-166cbdb7a33f",
        "storage_key": "property/6767906449165634/01a015c4-3553-734b-be57-166cbdb7a33f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, complete with agility obstacles and plenty of space for your furry friends to play and socialize.",
      "link": "",
      "alt_text": "A fenced-in dog park with agility equipment, red tunnel, and benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2d3beac1-fd2c-4189-9819-99c0e652ce7f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-38e1-75df-a465-e8e0068b5b90.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment and benches.",
        "public_id": "01a015c4-38e1-75df-a465-e8e0068b5b90",
        "storage_key": "property/6767906449165634/01a015c4-38e1-75df-a465-e8e0068b5b90.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, complete with agility equipment and ample space for your furry friends to play and socialize.",
      "link": "",
      "alt_text": "Dog park with agility equipment and benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2d42ba5b-c2c5-4581-8caf-1aba6e5665a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-494e-70da-b624-eb5a11b6a099.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstands, and a window.",
        "public_id": "01a015c4-494e-70da-b624-eb5a11b6a099",
        "storage_key": "property/6767906449165634/01a015c4-494e-70da-b624-eb5a11b6a099.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable queen-size bed, two wooden nightstands with lamps, and a large window with blinds and curtains.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstands, and a window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1adb54bb-1a66-47dd-99a1-e90a7ec6173a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-33e5-7062-bd26-ed339e86e579.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015c4-33e5-7062-bd26-ed339e86e579",
        "storage_key": "property/6767906449165634/01a015c4-33e5-7062-bd26-ed339e86e579.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the sparkling swimming pool, complete with comfortable lounge chairs and refreshing umbrellas.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and umbrellas",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f241995b-5457-47b9-899c-5cb529c24ded",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-2941-717a-8bdd-71015d0639a2.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, elliptical, weight machines, free weights, and weight benches.",
        "public_id": "01a015c4-2941-717a-8bdd-71015d0639a2",
        "storage_key": "property/6767906449165634/01a015c4-2941-717a-8bdd-71015d0639a2.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, equipped with cardio machines and free weights for a complete workout.",
      "link": "",
      "alt_text": "Gym with treadmills, elliptical, weight machines, free weights, and weight benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_98e55c2a-9e28-4f79-b3c7-dbbfda5567aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-241f-742a-a3d6-1ab24c6ec4b1.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical machines, weight machines, and a flat-screen TV.",
        "public_id": "01a015c4-241f-742a-a3d6-1ab24c6ec4b1",
        "storage_key": "property/6767906449165634/01a015c4-241f-742a-a3d6-1ab24c6ec4b1.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, equipped with a variety of cardio and strength training equipment.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical machines, weight machines, and a flat-screen TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b4191793-c434-4db8-b0a2-4fab21c5c0cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-2b65-776c-a90b-2b0e5e2570c3.webp",
      "image_media": {
        "alt_text": "Sparkling blue swimming pool with lounge chairs and umbrellas under a bright blue sky.",
        "public_id": "01a015c4-2b65-776c-a90b-2b0e5e2570c3",
        "storage_key": "property/6767906449165634/01a015c4-2b65-776c-a90b-2b0e5e2570c3.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning swimming pool, complete with comfortable lounge chairs and shaded areas perfect for a sunny afternoon.",
      "link": "",
      "alt_text": "Sparkling blue swimming pool with lounge chairs and umbrellas under a bright blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3c4c87eb-73a8-4b91-91fc-7769b5036863",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-20e1-7228-9320-bb460cba51a7.webp",
      "image_media": {
        "alt_text": "Business center with desks, computers, and printer near a bay window overlooking greenery.",
        "public_id": "01a015c4-20e1-7228-9320-bb460cba51a7",
        "storage_key": "property/6767906449165634/01a015c4-20e1-7228-9320-bb460cba51a7.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Utilize our convenient business center, equipped with computers and a printer, perfect for catching up on work or staying connected.",
      "link": "",
      "alt_text": "Business center with desks, computers, and printer near a bay window overlooking greenery.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a6014466-3f62-4561-a7ba-56b133744cbb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-1d29-7098-a0ae-1508ab9eec35.webp",
      "image_media": {
        "alt_text": "Community lounge with fireplace, seating, and bar area.",
        "public_id": "01a015c4-1d29-7098-a0ae-1508ab9eec35",
        "storage_key": "property/6767906449165634/01a015c4-1d29-7098-a0ae-1508ab9eec35.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind in our spacious community lounge, featuring a cozy fireplace, comfortable seating, and a full-service bar. Perfect for gatherings and events.",
      "link": "",
      "alt_text": "Community lounge with fireplace, seating, and bar area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ba28071e-53cd-4c95-a47a-159ed9cd50cb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-05c9-716f-847b-b66cff679953.webp",
      "image_media": {
        "alt_text": "Exterior view of the apartment complex office building with a welcoming entrance and manicured landscaping.",
        "public_id": "01a015c4-05c9-716f-847b-b66cff679953",
        "storage_key": "property/6767906449165634/01a015c4-05c9-716f-847b-b66cff679953.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to our beautiful apartment community's office. This charming building features an inviting entrance, surrounded by lush gardens and mature trees, creating a pleasant first impression for all residents and visitors.",
      "link": "",
      "alt_text": "Exterior view of the apartment complex office building with a welcoming entrance and manicured landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9d781a12-ad16-4f3d-8b5f-66f010351d38",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c3-fb50-711c-bf56-32fb836c5af7.webp",
      "image_media": {
        "alt_text": "The Greens of Bedford entrance with sign and landscaping.",
        "public_id": "01a015c3-fb50-711c-bf56-32fb836c5af7",
        "storage_key": "property/6767906449165634/01a015c3-fb50-711c-bf56-32fb836c5af7.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to The Greens of Bedford, featuring a beautiful entrance with a prominent sign and lush landscaping.",
      "link": "",
      "alt_text": "The Greens of Bedford entrance with sign and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_64167bc8-aa23-4900-bdae-56359d120571",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "11111 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain steakhouse known for its hand-cut steaks, ribs, and made-from-scratch sides.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and filet medallions, and their rolls with cinnamon butter are a highlight. They also highlight the affordable prices, fun atmosphere, and attentive service.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-902c-7442-a623-8b7e00695551.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-902c-7442-a623-8b7e00695551",
        "storage_key": "property/6767906449165634/019d2709-902c-7442-a623-8b7e00695551.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/tulsa-east-71st-st?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=10669544637791228065&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "36.0613876",
      "poi_longitude": "-95.852648",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-461-8891",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c1fe-773f-8e26-6e45ccfa8551.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c1fe-773f-8e26-6e45ccfa8551",
        "storage_key": "property/6767906449165634/019d2709-c1fe-773f-8e26-6e45ccfa8551.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dEXckyMtocRoVC4glHWEZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_0c6846d1-59e6-4ce3-8b9c-cd938902705a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "8711 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "People say this restaurant offers a diverse menu with delicious pasta, burgers, and cheesecake. They also highlight the attentive and friendly service, and the warm and welcoming atmosphere, ideal for a casual yet elevated evening out.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-8f9d-717f-8b1d-9624ff61e682.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8f9d-717f-8b1d-9624ff61e682",
        "storage_key": "property/6767906449165634/019d2709-8f9d-717f-8b1d-9624ff61e682.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/ok/tulsa-130.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=16222748060775136545&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "36.0614349",
      "poi_longitude": "-95.8795591",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-249-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c1fe-773f-8e26-6e45ccfa8551.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c1fe-773f-8e26-6e45ccfa8551",
        "storage_key": "property/6767906449165634/019d2709-c1fe-773f-8e26-6e45ccfa8551.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbxJhQ5aNtocRIb0o02jHIuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_4b5c3db2-fa3c-46fa-b8a5-69f60589fa39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "4810 S Yale Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Casual chain, known for battered chicken fingers, fries, Texas toast and signature sauce, as well as friendly service.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers and a tasty dipping sauce. They highlight the fair pricing and generous portions. They also like the fast and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-8fdb-71db-8766-62b603d8d2a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8fdb-71db-8766-62b603d8d2a6",
        "storage_key": "property/6767906449165634/019d2709-8fdb-71db-8766-62b603d8d2a6.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ok/tulsa/4810-s.-yale-avenue",
      "poi_directions_map_url": "https://maps.google.com/?cid=6097855623742206873&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "36.0929086",
      "poi_longitude": "-95.9228346",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-477-9354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c1fe-773f-8e26-6e45ccfa8551.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c1fe-773f-8e26-6e45ccfa8551",
        "storage_key": "property/6767906449165634/019d2709-c1fe-773f-8e26-6e45ccfa8551.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW0uXiuqStocRmbPFyGHvn1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_3cfc5f25-cbbe-48bf-b417-b59851a53dd9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "4933 E 41st St, Tulsa, OK 74135, USA",
      "poi_short_description": "Popular fast-food chain specializing in chicken sandwiches and nuggets.",
      "poi_long_description": "People say this fast food restaurant serves fresh food. They also highlight the friendly staff and fast service.\n\nOther reviews mention the drive-thru can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-8fff-76cd-b08d-b6b455038678.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8fff-76cd-b08d-b6b455038678",
        "storage_key": "property/6767906449165634/019d2709-8fff-76cd-b08d-b6b455038678.webp",
        "width": 1069,
        "height": 1280
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ok/southroads-shopping-center?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=13411138926925396352&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "36.1047058",
      "poi_longitude": "-95.919763",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-622-7815",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c1fe-773f-8e26-6e45ccfa8551.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c1fe-773f-8e26-6e45ccfa8551",
        "storage_key": "property/6767906449165634/019d2709-c1fe-773f-8e26-6e45ccfa8551.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW6nzsMeStocRgDnNfMzvHbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_bd522758-8314-4078-9cfd-78238ede6acf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Cheddar's Scratch Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "10708 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Family-friendly national chain serving classic American comfort foods, plus cocktails, beer and steaks.",
      "poi_long_description": "Diners say this traditional US American restaurant serves up delicious honey butter croissants, salmon, and steak. They also highlight the friendly and attentive service, reasonable prices, and generous portions.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-948d-74fb-8be2-df1f7ea0df42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-948d-74fb-8be2-df1f7ea0df42",
        "storage_key": "property/6767906449165634/019d2709-948d-74fb-8be2-df1f7ea0df42.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cheddars.com/locations/ok/tulsa/tulsa/2015?cmpid=br:csk_ag:ie_ch:loc_ca:CSKGMB_sn:gmb_gt:tulsa-ok-2015_pl:locurl_rd:1010",
      "poi_directions_map_url": "https://maps.google.com/?cid=11101010613821228024&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cheddars-scratch-kitchen",
      "poi_latitude": "36.06025",
      "poi_longitude": "-95.85707",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-307-2013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c1fe-773f-8e26-6e45ccfa8551.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c1fe-773f-8e26-6e45ccfa8551",
        "storage_key": "property/6767906449165634/019d2709-c1fe-773f-8e26-6e45ccfa8551.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM6XrprSNtocR-MOnbFa2Dpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_2b60be11-5cf3-400a-85c0-336c4fcc5954",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Woodland Hills Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "7021 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Spacious, clean, 2-level shopping center featuring a carousel for kids as well as a variety of food options.",
      "poi_long_description": "Visitors say this shopping center has a wide variety of stores, including Scheels, Macy's, Dillard's, and JCPenney, and a great food court with many options. They also highlight the clean, safe, and friendly atmosphere, and the family-friendly environment with activities for children.\n\nSome reviews mention the escalators can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-94b3-76d1-8eb6-8800c8e16617.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-94b3-76d1-8eb6-8800c8e16617",
        "storage_key": "property/6767906449165634/019d2709-94b3-76d1-8eb6-8800c8e16617.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/woodland-hills-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=6466318501171358790&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodland-hills-mall",
      "poi_latitude": "36.063341",
      "poi_longitude": "-95.881655",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-250-1449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c216-7108-ba71-612f455bbd1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c216-7108-ba71-612f455bbd1d",
        "storage_key": "property/6767906449165634/019d2709-c216-7108-ba71-612f455bbd1d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8fv_EJeNtocRRuzasmr6vFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_832820b7-a355-40b9-943b-d4ac6c724208",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "7130 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Food mart stocking meat, baked goods and household staples, plus bulk bins.",
      "poi_long_description": "Shoppers say this grocery store offers great savings on a wide variety of items, including bulk goods like candy, nuts, and spices, as well as fresh produce and quality meats. They also highlight the store's 24/7 accessibility, reasonable prices, and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-945a-7139-a5c0-a42402d13adc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-945a-7139-a5c0-a42402d13adc",
        "storage_key": "property/6767906449165634/019d2709-945a-7139-a5c0-a42402d13adc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8053298412458330468&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "36.0597141",
      "poi_longitude": "-95.8890336",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-888-7002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c169-762d-beb8-28ece40fa93b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c169-762d-beb8-28ece40fa93b",
        "storage_key": "property/6767906449165634/019d2709-c169-762d-beb8-28ece40fa93b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62eScyGNtocRZMnL6DwQw28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_5129baef-0a48-4ea0-bb08-9cb521e6bbe7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Pan-Asia Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "10003 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Asian grocery store featuring fresh produce and seafood. Also on offer: sushi and tea.",
      "poi_long_description": "People say this Asian grocery store offers a wide variety of fresh produce, live seafood, and Asian groceries, including a large selection of meats, spices, and noodles. They highlight the fair prices, the clean and organized store, and the delicious hot food, boba tea, and sushi available at the cafe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-94e0-7398-a12d-6a349efeb30b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-94e0-7398-a12d-6a349efeb30b",
        "storage_key": "property/6767906449165634/019d2709-94e0-7398-a12d-6a349efeb30b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.panasiasupermarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1484729550679765321&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pan-asia-supermarket",
      "poi_latitude": "36.0630212",
      "poi_longitude": "-95.8655271",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-940-7570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c169-762d-beb8-28ece40fa93b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c169-762d-beb8-28ece40fa93b",
        "storage_key": "property/6767906449165634/019d2709-c169-762d-beb8-28ece40fa93b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP1gpIX6NtocRSfHK76jRmhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_e530e029-446c-4b91-a8eb-974ce0359d88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "9136 S Yale Ave, Tulsa, OK 74137, USA",
      "poi_short_description": "Market selling organic produce and gluten-free grocery items.",
      "poi_long_description": "People say this grocery store offers a wide selection of healthy and organic foods, including fresh produce, a salad bar, and a variety of vitamins and supplements. They also highlight the clean and organized layout, the friendly and helpful staff, and the relaxed shopping experience.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-9900-719c-b16a-0d61376ffbf4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9900-719c-b16a-0d61376ffbf4",
        "storage_key": "property/6767906449165634/019d2709-9900-719c-b16a-0d61376ffbf4.webp",
        "width": 1280,
        "height": 603
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/yale?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=4690334156598386947&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "36.030638",
      "poi_longitude": "-95.9237179",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-879-0493",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c169-762d-beb8-28ece40fa93b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c169-762d-beb8-28ece40fa93b",
        "storage_key": "property/6767906449165634/019d2709-c169-762d-beb8-28ece40fa93b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp2KYkCCStocRA6HtoRBqF0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b9aa159b-c32f-41f5-a317-9e0f1166f3b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "1525 S Yale Ave, Tulsa, OK 74112, USA",
      "poi_short_description": "Chain hardware store and home center stocked with lawn equipment, appliances, paint and patio furniture.",
      "poi_long_description": "People say this home improvement store offers a wide selection of appliances and DIY products. They also highlight the helpful staff and quick checkout.\n\nOther reviews mention the inventory can be inaccurate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-98e5-7677-8f06-e2d6e9968cb8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-98e5-7677-8f06-e2d6e9968cb8",
        "storage_key": "property/6767906449165634/019d2709-98e5-7677-8f06-e2d6e9968cb8.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OK-Tulsa/1580?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1580-_-na-_-0-_-0&y_source=1_MTE4NDQwNC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12278391127478819263&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "36.1396197",
      "poi_longitude": "-95.9196011",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-712-8199",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c216-7108-ba71-612f455bbd1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c216-7108-ba71-612f455bbd1d",
        "storage_key": "property/6767906449165634/019d2709-c216-7108-ba71-612f455bbd1d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJcRFpChXttocRv9muPq2bZao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_f6409732-c923-4868-968a-d366cc464793",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Oral Roberts University",
      "poi_type": "Education",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74171, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-9a0c-751f-a4b2-4a2fd89be0d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9a0c-751f-a4b2-4a2fd89be0d4",
        "storage_key": "property/6767906449165634/019d2709-9a0c-751f-a4b2-4a2fd89be0d4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://oru.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13173931362498967750&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oral-roberts-university",
      "poi_latitude": "36.0508093",
      "poi_longitude": "-95.9528284",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-495-6161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c1ae-716c-b55e-f7186b8d8043.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c1ae-716c-b55e-f7186b8d8043",
        "storage_key": "property/6767906449165634/019d2709-c1ae-716c-b55e-f7186b8d8043.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdwdeD7iTtocRxvgglcY007Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_60a03806-a3d4-4357-9811-8be264d4ce6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Tulsa Community College Southeast Campus",
      "poi_type": "Education",
      "poi_address": "10300 E 81st St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-99af-706c-9b47-f43db34a5bf1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-99af-706c-9b47-f43db34a5bf1",
        "storage_key": "property/6767906449165634/019d2709-99af-706c-9b47-f43db34a5bf1.webp",
        "width": 1280,
        "height": 924
      },
      "poi_business_url": "https://www.tulsacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8389070837534418764&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-community-college-southeast-campus",
      "poi_latitude": "36.0448034",
      "poi_longitude": "-95.8624934",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-595-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c1ae-716c-b55e-f7186b8d8043.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c1ae-716c-b55e-f7186b8d8043",
        "storage_key": "property/6767906449165634/019d2709-c1ae-716c-b55e-f7186b8d8043.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY1olEM6NtocRTOfTwnr3a3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_4700186c-559f-40e7-8cf1-482db1444a01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Hardesty Regional Library",
      "poi_type": "Education",
      "poi_address": "8316 E 93rd St, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed library featuring kids' sections (some with play areas and puzzles) plus meeting rooms and study space.",
      "poi_long_description": "People say this public library offers a wide selection of books, study rooms, and computers. They highlight the clean and safe environment, and the helpful staff. They also like the separate kids and adult sections, and the dedicated teen space. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-9cec-76da-bdfc-18b6b55289ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9cec-76da-bdfc-18b6b55289ee",
        "storage_key": "property/6767906449165634/019d2709-9cec-76da-bdfc-18b6b55289ee.webp",
        "width": 500,
        "height": 375
      },
      "poi_business_url": "http://www.tulsalibrary.org/hardesty",
      "poi_directions_map_url": "https://maps.google.com/?cid=3083775875462030879&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hardesty-regional-library",
      "poi_latitude": "36.0268456",
      "poi_longitude": "-95.8830539",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-549-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c1ae-716c-b55e-f7186b8d8043.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c1ae-716c-b55e-f7186b8d8043",
        "storage_key": "property/6767906449165634/019d2709-c1ae-716c-b55e-f7186b8d8043.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKe3yqg6OtocRH2bV99HFyyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_2977a32b-1cdf-4bbe-8253-b9f16985bcfa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "OU-Tulsa",
      "poi_type": "Education",
      "poi_address": "4502 E 41st St, Tulsa, OK 74135, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-9dee-751e-870c-001fee0ba2ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9dee-751e-870c-001fee0ba2ee",
        "storage_key": "property/6767906449165634/019d2709-9dee-751e-870c-001fee0ba2ee.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://tulsa.ou.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=247462858016865972&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ou-tulsa",
      "poi_latitude": "36.1024131",
      "poi_longitude": "-95.9259796",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-660-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c1ae-716c-b55e-f7186b8d8043.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c1ae-716c-b55e-f7186b8d8043",
        "storage_key": "property/6767906449165634/019d2709-c1ae-716c-b55e-f7186b8d8043.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcz8INcGStocRtL4ygygqbwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_4458b506-5bcb-4af3-92fa-11a85b82b28f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Martin Regional Library",
      "poi_type": "Education",
      "poi_address": "2601 S Garnett Rd, Tulsa, OK 74129, USA",
      "poi_short_description": "Public library with a range of services, including faxing, computers, and meetings, plus Vietnamese books.",
      "poi_long_description": "People say this public library offers a wide selection of books, comfortable seating, and convenient printing services. They highlight the quiet atmosphere, helpful staff, and friendly librarians. They also like the charging stations and the monthly vegan potluck. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-9e7b-7558-a714-98b526977682.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9e7b-7558-a714-98b526977682",
        "storage_key": "property/6767906449165634/019d2709-9e7b-7558-a714-98b526977682.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tulsalibrary.org/martin/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6046822168243383481&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "martin-regional-library",
      "poi_latitude": "36.1265968",
      "poi_longitude": "-95.8505489",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-549-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c1ae-716c-b55e-f7186b8d8043.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c1ae-716c-b55e-f7186b8d8043",
        "storage_key": "property/6767906449165634/019d2709-c1ae-716c-b55e-f7186b8d8043.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF1eFsi7ztocRuawafrmg6lM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_d8972d3c-a27a-4703-8949-239ba18eda48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "3328 E 51st St, Tulsa, OK 74135, USA",
      "poi_short_description": "Family-friendly chain featuring trampolines, climbing walls, ropes courses and other active recreational options.",
      "poi_long_description": "People say this amusement park offers a variety of activities, including trampolines, go-karts, zip lines, and virtual reality. They also highlight the helpful staff and the fun atmosphere for birthday parties.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-9f16-74bf-810a-4b65351b4a42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9f16-74bf-810a-4b65351b4a42",
        "storage_key": "property/6767906449165634/019d2709-9f16-74bf-810a-4b65351b4a42.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.urbanair.com/oklahoma-tulsa/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=3062250087465279410&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "36.0884996",
      "poi_longitude": "-95.9384116",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-770-9987",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c56a-736c-b39b-933a427e1090",
        "storage_key": "property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1wX9dvyTtocRst_G5DpMfyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_44caa4ca-a116-40c2-9409-c5a896a4e883",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Mabee Center",
      "poi_type": "Entertainment",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "Sprawling facility for concerts, basketball events and graduations, plus other events.",
      "poi_long_description": "Entertainment venue hosting nationally known performers, church services, sports & family events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-a26b-77ac-acc0-195d6b21e034.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a26b-77ac-acc0-195d6b21e034",
        "storage_key": "property/6767906449165634/019d2709-a26b-77ac-acc0-195d6b21e034.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://mabeecenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7042245147778354535&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mabee-center",
      "poi_latitude": "36.0480386",
      "poi_longitude": "-95.9557686",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-495-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c56a-736c-b39b-933a427e1090",
        "storage_key": "property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuUFxgMeTtocRZw2MhqYUu2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_3b083881-b7fe-4c41-b63e-8b7f69e339b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Sky Zone Trampoline Park",
      "poi_type": "Entertainment",
      "poi_address": "8306 E 61st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Gravity-defying entertainment venue with state-of-the-art trampolines, plus dodgeball courts.",
      "poi_long_description": "People say this amusement park offers fun trampolines, attractions, and a zip line. They also highlight the massage chairs for adults and the designated space for birthday parties.\n\nOther reviews mention the customer service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-a3d4-75fd-84ad-bc17367a2ae1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a3d4-75fd-84ad-bc17367a2ae1",
        "storage_key": "property/6767906449165634/019d2709-a3d4-75fd-84ad-bc17367a2ae1.webp",
        "width": 1280,
        "height": 718
      },
      "poi_business_url": "https://www.skyzone.com/tulsa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2967499010622421820&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sky-zone-trampoline-park",
      "poi_latitude": "36.07405900000001",
      "poi_longitude": "-95.883873",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-877-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c56a-736c-b39b-933a427e1090",
        "storage_key": "property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM3PGwZ2NtocRPPt4r6CsLik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_ac86c74f-1043-4ecb-9b82-100d39df0920",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Golden Driller Statue",
      "poi_type": "Entertainment",
      "poi_address": "Tulsa Expo Center, 4145 E 21st St, Tulsa, OK 74114, USA",
      "poi_short_description": "Golden, roadside landmark, built in 1953 in Tulsa, of an oil worker (nicknamed “the Driller”), 75 feet tall, adorned with a T-shirt, representing a time when the town was known as the “oil capital of the world”.",
      "poi_long_description": "Visitors say this historical landmark is a must-see, especially for those from out of town, and they praise the statue's impressive size. They also highlight that parking is free and it's a great place to stop for photos, especially during events like the Tulsa State Fair.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-a367-7457-80d0-c6c76cd09756.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a367-7457-80d0-c6c76cd09756",
        "storage_key": "property/6767906449165634/019d2709-a367-7457-80d0-c6c76cd09756.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://exposquare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14322764790652212651&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-driller-statue",
      "poi_latitude": "36.1337734",
      "poi_longitude": "-95.9311081",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-596-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c56a-736c-b39b-933a427e1090",
        "storage_key": "property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJswh6RCPttocRqxVMHLGuxMY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_7038cc2e-11b1-4eea-8b76-9e1febdb4997",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Slick City Action Park",
      "poi_type": "Entertainment",
      "poi_address": "5352 E Skelly Dr, Tulsa, OK 74135, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this amusement park offers a variety of fun slides, a basketball court, and a play area for younger children. They also highlight the friendly and helpful staff, and the clean and safe environment.\n\nOther reviews mention the concessions can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-a3ec-77df-ad2c-c72cd1c6ba6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a3ec-77df-ad2c-c72cd1c6ba6b",
        "storage_key": "property/6767906449165634/019d2709-a3ec-77df-ad2c-c72cd1c6ba6b.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://slickcity.com/ok-tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=12324602171454774354&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "slick-city-action-park",
      "poi_latitude": "36.0979811",
      "poi_longitude": "-95.9157069",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-818-7423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c56a-736c-b39b-933a427e1090",
        "storage_key": "property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFytTvJWTtocRUtyRW2DICas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_0babebe2-538b-47fe-b983-582eee332f07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "10642 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Athletic country club featuring indoor and outdoor pools, yoga classes, and basketball and pickleball courts, plus a cafe.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-a745-762c-afe9-97fd8e637897.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a745-762c-afe9-97fd8e637897",
        "storage_key": "property/6767906449165634/019d2709-a745-762c-afe9-97fd8e637897.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/ok/south-tulsa.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=3628922520137756888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "36.0093414",
      "poi_longitude": "-95.8899718",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-364-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c56a-736c-b39b-933a427e1090",
        "storage_key": "property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEwVCKhaOtocR2PA5Is6FXDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_eb3e790b-ee3b-4bb1-b430-156c14e032c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Crunch Fitness - Tulsa",
      "poi_type": "Health and Wellness",
      "poi_address": "7827 E 91st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Friendly gym, fitness-oriented chain, featuring cardio equipment, group classes, and personal-training services.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and group classes, and has a clean facility with helpful and knowledgeable staff.\n\nOther reviews mention the membership cancellation process can be difficult and the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-a866-76e8-ab73-1529e5fa80d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a866-76e8-ab73-1529e5fa80d2",
        "storage_key": "property/6767906449165634/019d2709-a866-76e8-ab73-1529e5fa80d2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=3614973288206348263&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---tulsa",
      "poi_latitude": "36.0337164",
      "poi_longitude": "-95.8883964",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 539-842-0966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c56a-736c-b39b-933a427e1090",
        "storage_key": "property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB747NHCNtocR568QfA33KjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1ec2e474-eefc-4e9f-b114-0e7459fd9750",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Crunch Fitness - Broken Arrow",
      "poi_type": "Health and Wellness",
      "poi_address": "3701 S Elm Pl, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Gym offering fitness classes, cardio equipment, and personal training, plus tanning.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment and machines. They also highlight the friendly and helpful staff, and the clean and spacious facility.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-a80c-727d-8d09-379348b1ae5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a80c-727d-8d09-379348b1ae5b",
        "storage_key": "property/6767906449165634/019d2709-a80c-727d-8d09-379348b1ae5b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/brokenarrow",
      "poi_directions_map_url": "https://maps.google.com/?cid=7237271301754615382&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---broken-arrow",
      "poi_latitude": "36.0152872",
      "poi_longitude": "-95.7956716",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-395-5070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c56a-736c-b39b-933a427e1090",
        "storage_key": "property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0wtAG4WJtocRVnY2fOfzb2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_17c6cdb0-4a51-4d45-8d82-54023b2fb79e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1808 N Elm Pl, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Chain gym offering a variety of workout equipment, including tanning beds, in a clean environment.",
      "poi_long_description": "People say this gym offers a wide selection of equipment and is clean and well-maintained. They highlight the affordable membership and convenient location. They also like the friendly and supportive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-a88b-7347-9e1b-eb150d086f98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a88b-7347-9e1b-eb150d086f98",
        "storage_key": "property/6767906449165634/019d2709-a88b-7347-9e1b-eb150d086f98.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/broken-arrow-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=8211862053813118143&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "36.0700775",
      "poi_longitude": "-95.7999697",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-739-6224",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c56a-736c-b39b-933a427e1090",
        "storage_key": "property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNfEd95mLtocRv2QKlgdl9nE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_603a9bc4-4919-46b3-acf1-42d52a890d8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "iidentity salon",
      "poi_type": "Health and Wellness",
      "poi_address": "2731 S Harvard Ave, Tulsa, OK 74114, USA",
      "poi_short_description": "Hair styling salon with a friendly staff and a warm atmosphere, offering cuts and coloring services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-ab9a-7494-9b40-d80c3f65ce69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-ab9a-7494-9b40-d80c3f65ce69",
        "storage_key": "property/6767906449165634/019d2709-ab9a-7494-9b40-d80c3f65ce69.webp",
        "width": 960,
        "height": 893
      },
      "poi_business_url": "http://www.iidentitysalon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9820300745508314431&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "iidentity-salon",
      "poi_latitude": "36.1232992",
      "poi_longitude": "-95.9400579",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-747-2566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c56a-736c-b39b-933a427e1090",
        "storage_key": "property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ8vHnFGTtocRP92Gc3-3SIg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_494e54f8-c0c6-44a2-8baf-5d3f85161865",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "10GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "9142 E 31st St, Tulsa, OK 74145, USA",
      "poi_short_description": "Gym offering cardio and strength-training equipment, as well as Pilates, yoga, and cycling classes.",
      "poi_long_description": "People say this gym offers a wide variety of new equipment, including free weights, machines, and cardio options, as well as classes and tanning booths. They highlight the clean facilities, spacious layout, and 24/7 availability, making it convenient for people with unpredictable schedules. They also like the friendly, helpful, and understanding staff, and the welcoming, non-judgmental atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-acc5-742b-8598-e6b5c5e0fcc9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-acc5-742b-8598-e6b5c5e0fcc9",
        "storage_key": "property/6767906449165634/019d2709-acc5-742b-8598-e6b5c5e0fcc9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://10gym.com/east-tulsa-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16362762748097342813&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "10gym",
      "poi_latitude": "36.1175059",
      "poi_longitude": "-95.8708861",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-438-0193",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c56a-736c-b39b-933a427e1090",
        "storage_key": "property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh4own9SMtocRXS1WmAY2FOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ca05e15d-323e-423e-9c71-bf2f9a9bf56f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "4915 E 41st St Suite A, Tulsa, OK 74135, USA",
      "poi_short_description": "Beauty retailer carrying a wide selection of products and offering salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-ae32-75cd-902b-01e637b71c0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-ae32-75cd-902b-01e637b71c0d",
        "storage_key": "property/6767906449165634/019d2709-ae32-75cd-902b-01e637b71c0d.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/tulsa-ok-131",
      "poi_directions_map_url": "https://maps.google.com/?cid=10581466912609131404&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "36.1058946",
      "poi_longitude": "-95.9208289",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-664-5916",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c56a-736c-b39b-933a427e1090",
        "storage_key": "property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWeUzsceStocRjNudEBjs2JI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_4c35ee2f-2631-493c-9fac-1012233ef82c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Saint Francis Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "6161 S Yale Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-ae6d-7764-9b21-68fc44cf096d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-ae6d-7764-9b21-68fc44cf096d",
        "storage_key": "property/6767906449165634/019d2709-ae6d-7764-9b21-68fc44cf096d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.saintfrancis.com/location/saint-francis-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=60921030837772717&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saint-francis-hospital",
      "poi_latitude": "36.0717124",
      "poi_longitude": "-95.919824",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-494-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c595-732c-ac56-578f0e73438d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c595-732c-ac56-578f0e73438d",
        "storage_key": "property/6767906449165634/019d2709-c595-732c-ac56-578f0e73438d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbj84V-StocRraFv0lpv2AA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_bec6c1f7-09e3-4f59-892d-d34dd8d2eb96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Hillcrest South",
      "poi_type": "Health and Wellness",
      "poi_address": "8801 S 101st E Ave, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-b07a-761d-885d-c58d4ebb66c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b07a-761d-885d-c58d4ebb66c1",
        "storage_key": "property/6767906449165634/019d2709-b07a-761d-885d-c58d4ebb66c1.webp",
        "width": 1280,
        "height": 890
      },
      "poi_business_url": "https://hillcrest.com/find-a-provider/location/hillcrestsouth8801s101steave/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4505690926352009573&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hillcrest-south",
      "poi_latitude": "36.0354556",
      "poi_longitude": "-95.8635828",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-294-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c595-732c-ac56-578f0e73438d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c595-732c-ac56-578f0e73438d",
        "storage_key": "property/6767906449165634/019d2709-c595-732c-ac56-578f0e73438d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJx-fcY9aNtocRZYnpfAZuhz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_a7d4d3aa-1e1f-42bc-aa84-361617a1b40d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Rhema Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this park offers a beautiful display of Christmas lights, with a light show synchronized to music. They highlight the festive and family-friendly atmosphere, and the opportunity to walk or drive through the light experience. They also like the availability of hot cocoa, popcorn, and horse-drawn carriage rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-b1f9-736e-bbc6-c24f3ce1b5af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b1f9-736e-bbc6-c24f3ce1b5af",
        "storage_key": "property/6767906449165634/019d2709-b1f9-736e-bbc6-c24f3ce1b5af.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rhemalights.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7029601498986534882&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rhema-park",
      "poi_latitude": "36.0599323",
      "poi_longitude": "-95.808211",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-258-1588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c5c2-741b-bd04-748f0c83bf1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5c2-741b-bd04-748f0c83bf1a",
        "storage_key": "property/6767906449165634/019d2709-c5c2-741b-bd04-748f0c83bf1a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSQLUiIyLtocR4lelo1EpjmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7ae4b4bd-a479-4c87-bc18-ced3acd9e3c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "LaFortune Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5202 S Hudson Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Vast park, with playground areas, golf options, tennis courts, a pool and a community center.",
      "poi_long_description": "People say this park offers a golf course, playgrounds, walking trails, and picnic areas with grills. They highlight the park is clean, well-maintained, and safe, with plenty of parking and covered pavilions. They also like the wide walkways and the peaceful, quiet atmosphere. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-b2c5-7228-832a-771f6cff92ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b2c5-7228-832a-771f6cff92ab",
        "storage_key": "property/6767906449165634/019d2709-b2c5-7228-832a-771f6cff92ab.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www2.tulsacounty.org/parks/parks-facilities/lafortune-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16150311355247615027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lafortune-park",
      "poi_latitude": "36.0830954",
      "poi_longitude": "-95.9178327",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-496-6220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c5c2-741b-bd04-748f0c83bf1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5c2-741b-bd04-748f0c83bf1a",
        "storage_key": "property/6767906449165634/019d2709-c5c2-741b-bd04-748f0c83bf1a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh59BfPOStocRM9x9DZxuIeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e9fc8554-c611-49e2-a154-0c26de782d1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Elam Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74011, USA",
      "poi_short_description": "Fenced park featuring picnic tables and a playground for children.",
      "poi_long_description": "People say this park offers a variety of playground equipment, including slides, swings, and a zipline, as well as picnic tables, soccer fields, and a water fountain with a bottle refill station. They highlight the park's clean bathrooms, shaded seating areas, and fenced-in playground, making it safe and enjoyable for children of all ages. They also like the park's accessible layout and thoughtful design, especially for toddlers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-b312-76aa-90a8-61b77b2ebccf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b312-76aa-90a8-61b77b2ebccf",
        "storage_key": "property/6767906449165634/019d2709-b312-76aa-90a8-61b77b2ebccf.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.brokenarrowok.gov/Home/Components/News/News/2234/15",
      "poi_directions_map_url": "https://maps.google.com/?cid=8281012522592314667&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "elam-park",
      "poi_latitude": "36.0062955",
      "poi_longitude": "-95.8209464",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-251-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c5c2-741b-bd04-748f0c83bf1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5c2-741b-bd04-748f0c83bf1a",
        "storage_key": "property/6767906449165634/019d2709-c5c2-741b-bd04-748f0c83bf1a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW_XMAgCPtocRKyWtvQMR7HI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2d6155a5-9eb7-496c-887b-2e1ee4bb0bd7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Hunter Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5804 E 91st St, Tulsa, OK 74137, USA",
      "poi_short_description": "Well-maintained park featuring a playground for kids and a dog park for pets, plus a splash pad and a pond for fishing.",
      "poi_long_description": "People say this park offers a disc golf course, a dog park with separate areas for large and small dogs, and a pond with fishing piers. They highlight the peaceful and safe environment, and the extensive dog park with play features and picnic spots. They also like the wooded trails and the availability of water fountains for dogs. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-b60d-7359-b955-4b62b065b30b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b60d-7359-b955-4b62b065b30b",
        "storage_key": "property/6767906449165634/019d2709-b60d-7359-b955-4b62b065b30b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityoftulsa.org/culture--recreation/tulsa-parks.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=13505697753323470752&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hunter-park",
      "poi_latitude": "36.0298785",
      "poi_longitude": "-95.9117817",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-596-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c5c2-741b-bd04-748f0c83bf1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5c2-741b-bd04-748f0c83bf1a",
        "storage_key": "property/6767906449165634/019d2709-c5c2-741b-bd04-748f0c83bf1a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwzzqpPeRtocRoP-i5ozgbbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b4502765-06a5-4f9d-9b30-386d0b00a984",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Haikey Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11327 S Garnett Rd, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Calm park featuring frisbee golf, disc golf, swings and a playground for kids.",
      "poi_long_description": "People say this park offers a disc golf course, multiple playgrounds, walking trails, and picnic areas. They highlight the park is large, well-maintained, and has plenty of shaded areas. They also like the clean pavilions, volleyball, horseshoes, and open spaces for various activities. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-b767-748e-a8be-8f7962a5f49c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b767-748e-a8be-8f7962a5f49c",
        "storage_key": "property/6767906449165634/019d2709-b767-748e-a8be-8f7962a5f49c.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15453125230281067031&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "haikey-creek-park",
      "poi_latitude": "35.9918271",
      "poi_longitude": "-95.8526659",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-369-5998",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c5c2-741b-bd04-748f0c83bf1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5c2-741b-bd04-748f0c83bf1a",
        "storage_key": "property/6767906449165634/019d2709-c5c2-741b-bd04-748f0c83bf1a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkz_xefyOtocRF4qH1IWHdNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bda0ee5d-aa1d-4d9d-81eb-d4ef4922882c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Harvey Young Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1419 S 135th E Ave, Tulsa, OK 74108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-b897-725e-a1fb-5004be1561e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b897-725e-a1fb-5004be1561e3",
        "storage_key": "property/6767906449165634/019d2709-b897-725e-a1fb-5004be1561e3.webp",
        "width": 1242,
        "height": 932
      },
      "poi_business_url": "http://harvey-young-airport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11091711320843246332&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "harvey-young-airport",
      "poi_latitude": "36.1412138",
      "poi_longitude": "-95.8256711",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-298-4044",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c6d7-77ff-9aaa-7f3a854f9147.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c6d7-77ff-9aaa-7f3a854f9147",
        "storage_key": "property/6767906449165634/019d2709-c6d7-77ff-9aaa-7f3a854f9147.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJffM4REPztocR_FoKDq6s7Zk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_4bd924a4-2e7c-443e-8a6e-58d0ca1cf483",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Cityplex Towers",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2488 E 81st St, Tulsa, OK 74137, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-b804-732a-891d-13aaef1d90ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b804-732a-891d-13aaef1d90ba",
        "storage_key": "property/6767906449165634/019d2709-b804-732a-891d-13aaef1d90ba.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.cityplextowers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12250163942111608689&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cityplex-towers",
      "poi_latitude": "36.0427518",
      "poi_longitude": "-95.9528286",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-493-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c56a-736c-b39b-933a427e1090",
        "storage_key": "property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuTNcyMaTtocRcX_cgTNTAao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4766fcd4-5146-4727-9e31-fd630db60a8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Hilti - Operations Center Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5400 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-bb61-7795-a000-a754f6a7201d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-bb61-7795-a000-a754f6a7201d",
        "storage_key": "property/6767906449165634/019d2709-bb61-7795-a000-a754f6a7201d.webp",
        "width": 760,
        "height": 512
      },
      "poi_business_url": "http://hilti.to/ubo2wq",
      "poi_directions_map_url": "https://maps.google.com/?cid=4109057745683559288&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hilti---operations-center-corporate-office",
      "poi_latitude": "36.0872879",
      "poi_longitude": "-95.8430938",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-252-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c56a-736c-b39b-933a427e1090",
        "storage_key": "property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUUE4gPGMtocReDMJvT9OBjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b774008d-6fa7-4089-be89-2c2fd1d9960c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Enovation Controls",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5311 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-bd09-724b-bc93-4ad1aff68881.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-bd09-724b-bc93-4ad1aff68881",
        "storage_key": "property/6767906449165634/019d2709-bd09-724b-bc93-4ad1aff68881.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.enovationcontrols.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1461315099535642429&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "enovation-controls",
      "poi_latitude": "36.0861778",
      "poi_longitude": "-95.8391635",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-317-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c56a-736c-b39b-933a427e1090",
        "storage_key": "property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4_tas_OMtocRPY-8NFeiRxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c9f753cc-3934-411c-a19c-859469288459",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Mill Creek General Offices",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6974 E 38th St, Tulsa, OK 74145, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.millcreeklumber.com/distribution_general_offices_tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=17106239654103162435&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mill-creek-general-offices",
      "poi_latitude": "36.1071459",
      "poi_longitude": "-95.8972379",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-794-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c56a-736c-b39b-933a427e1090",
        "storage_key": "property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBYu7OliNtocRQx6FKVWSZe0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5ca10581-5e4c-4613-9322-31205c3864a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Air Hygiene International, Inc. - Stack and Emissions Testing",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 W Tacoma St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-bc69-735a-8356-49303b0f714f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-bc69-735a-8356-49303b0f714f",
        "storage_key": "property/6767906449165634/019d2709-bc69-735a-8356-49303b0f714f.webp",
        "width": 1280,
        "height": 613
      },
      "poi_business_url": "https://www.airhygiene.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17853602463665443212&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "air-hygiene-international-inc---stack-and-emissions-testing",
      "poi_latitude": "36.0713795",
      "poi_longitude": "-95.8092029",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-307-8865",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c56a-736c-b39b-933a427e1090",
        "storage_key": "property/6767906449165634/019d2709-c56a-736c-b39b-933a427e1090.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Ut31oWLtocRjFHRJ9m8xPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_a8ba5273-1824-45f8-88bf-ef3b75765a40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Jefferson Elementary School",
      "poi_type": "Education",
      "poi_address": "8418 S 107th E Ave, Tulsa, OK 74133, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3571407557531304534&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jefferson-elementary-school",
      "poi_latitude": "36.0407212",
      "poi_longitude": "-95.8576676",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-357-4339",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-e841-743c-8b09-da39eb36db51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-e841-743c-8b09-da39eb36db51",
        "storage_key": "property/6767906449165634/019cfb49-e841-743c-8b09-da39eb36db51.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6ZuzTi2MtocRVoLMXkAwkDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_01168c46-1ad0-4938-95aa-db71bccda165",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Union 6th/7th Grade Center",
      "poi_type": "Education",
      "poi_address": "10100 E 61st St, Tulsa, OK 74133, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d7913-2c5b-757e-9e94-7f240d05ca81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-2c5b-757e-9e94-7f240d05ca81",
        "storage_key": "property/6767906449165634/019d7913-2c5b-757e-9e94-7f240d05ca81.webp",
        "width": 640,
        "height": 360
      },
      "poi_business_url": "http://www.unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12357368135835625738&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-6th-7th-grade-center",
      "poi_latitude": "36.0750199",
      "poi_longitude": "-95.8647424",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-357-4326",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-e841-743c-8b09-da39eb36db51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-e841-743c-8b09-da39eb36db51",
        "storage_key": "property/6767906449165634/019cfb49-e841-743c-8b09-da39eb36db51.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG0q97M9mtocRCqk279gwfqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_76d1c980-ea36-47c9-9afe-370fc7aca6f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Union Eighth Grade Center",
      "poi_type": "Education",
      "poi_address": "6501 S Garnett Rd, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d7913-2c5b-757e-9e94-7b075efb0ac1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-2c5b-757e-9e94-7b075efb0ac1",
        "storage_key": "property/6767906449165634/019d7913-2c5b-757e-9e94-7b075efb0ac1.webp",
        "width": 640,
        "height": 360
      },
      "poi_business_url": "http://unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8773159022692442711&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-eighth-grade-center",
      "poi_latitude": "36.0671931",
      "poi_longitude": "-95.8503859",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-357-4325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-e841-743c-8b09-da39eb36db51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-e841-743c-8b09-da39eb36db51",
        "storage_key": "property/6767906449165634/019cfb49-e841-743c-8b09-da39eb36db51.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJwUczVGMtocRV6KYIaaFwHk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_fa9e0908-1f75-45de-9833-897ba4b665fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Union High School S.T.E.M. Building",
      "poi_type": "Education",
      "poi_address": "Tulsa, OK 74133, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2228436292019187956&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-high-school-s-t-e-m-building",
      "poi_latitude": "36.07223889999999",
      "poi_longitude": "-95.8668365",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-e841-743c-8b09-da39eb36db51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-e841-743c-8b09-da39eb36db51",
        "storage_key": "property/6767906449165634/019cfb49-e841-743c-8b09-da39eb36db51.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEUoJZ12NtocR9HBkNgD_7B4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_75db8af2-8e87-4530-8524-0b357d8e734e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "The University of Tulsa",
      "poi_type": "Education",
      "poi_address": "800 S Tucker Dr, Tulsa, OK 74104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d7913-2867-74af-83fb-5a6f8018a699.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-2867-74af-83fb-5a6f8018a699",
        "storage_key": "property/6767906449165634/019d7913-2867-74af-83fb-5a6f8018a699.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utulsa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12534755682749092613&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-university-of-tulsa",
      "poi_latitude": "36.1520526",
      "poi_longitude": "-95.9460753",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 52 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-631-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-e841-743c-8b09-da39eb36db51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-e841-743c-8b09-da39eb36db51",
        "storage_key": "property/6767906449165634/019cfb49-e841-743c-8b09-da39eb36db51.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM0KAdPzstocRBZORqOFl9K0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_52f874cb-a0b1-4454-a5a5-1b67053f56b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Savoy",
      "poi_type": "Restaurants",
      "poi_address": "6033 S Sheridan Rd, Tulsa, OK 74145, USA",
      "poi_short_description": "Old-fashioned family-owned cafe known for its hearty, homestyle meals, cinnamon rolls & pies.",
      "poi_long_description": "People say this brunch restaurant serves delicious cinnamon rolls, biscuits and gravy, and omelets. They highlight the generous portions, fresh ingredients, and homemade baked goods. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d7913-2d21-712e-874f-f5e355edb4aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-2d21-712e-874f-f5e355edb4aa",
        "storage_key": "property/6767906449165634/019d7913-2d21-712e-874f-f5e355edb4aa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.eatsavoy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14916269992354251298&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "savoy",
      "poi_latitude": "36.0765401",
      "poi_longitude": "-95.903519",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-494-5621",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-e830-724a-a2d0-b6b2e75e4f4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-e830-724a-a2d0-b6b2e75e4f4d",
        "storage_key": "property/6767906449165634/019cfb49-e830-724a-a2d0-b6b2e75e4f4d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCaXcLYeStocRIgIYPIc8Ac8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brunch_restaurant"
    },
    {
      "id": "custom_f53ded16-52a8-44b6-b556-d5c48468d6b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Bonefish Grill",
      "poi_type": "Restaurants",
      "poi_address": "4651 W Kenosha St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Contemporary grill chain offering a seafood-centric menu, plus steaks & cocktails.",
      "poi_long_description": "People say this seafood restaurant serves delicious Bang Bang shrimp, Imperial Cod, and Brussels sprouts. They highlight the excellent service, welcoming atmosphere, and tasty complimentary bread. They also like the attentive staff and the perfect music for the occasion.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d7913-2eae-76a1-9c60-a10a116bc453.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-2eae-76a1-9c60-a10a116bc453",
        "storage_key": "property/6767906449165634/019d7913-2eae-76a1-9c60-a10a116bc453.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.bonefishgrill.com/oklahoma/broken-arrow/4651-w.-kenosha-street?y_source=1_MTU1MDI2OTItNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11058823268018440839&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bonefish-grill",
      "poi_latitude": "36.059982",
      "poi_longitude": "-95.8478642",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-252-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-e830-724a-a2d0-b6b2e75e4f4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-e830-724a-a2d0-b6b2e75e4f4d",
        "storage_key": "property/6767906449165634/019cfb49-e830-724a-a2d0-b6b2e75e4f4d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6wz1zUiMtocRh0oQjCvVeJk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_f638a110-7aa3-4432-b8c4-6747e8dcff71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Tulsa’s Incredible Food and Fun",
      "poi_type": "Restaurants",
      "poi_address": "8314 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Popular place for parties offering go-karts, rides, games & pizza with an all-you-can-eat buffet.",
      "poi_long_description": "People say this buffet restaurant offers a wide variety of food, including pizza, hot dogs, tacos, and a salad bar, and has fun games and attractions like laser tag, bumper cars, and a roller coaster. They also highlight the fun, family-friendly atmosphere and the helpful, friendly staff.\n\nOther reviews mention some games can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d7913-3181-766e-aa61-60afc4ebe4c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-3181-766e-aa61-60afc4ebe4c1",
        "storage_key": "property/6767906449165634/019d7913-3181-766e-aa61-60afc4ebe4c1.webp",
        "width": 502,
        "height": 270
      },
      "poi_business_url": "https://incrediblefoodandfun.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16906715592224650215&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-s-incredible-food-and-fun",
      "poi_latitude": "36.0589793",
      "poi_longitude": "-95.8832543",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-294-8671",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-e830-724a-a2d0-b6b2e75e4f4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-e830-724a-a2d0-b6b2e75e4f4d",
        "storage_key": "property/6767906449165634/019cfb49-e830-724a-a2d0-b6b2e75e4f4d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJidT2-ZONtocR57MbaUG4oOo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_5b9a68f9-ec13-41cb-a061-b79451d7e282",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Smashburger",
      "poi_type": "Restaurants",
      "poi_address": "10830 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Counter-serve chain featuring signature smashed burgers, plus sides & shakes.",
      "poi_long_description": "People say this hamburger restaurant serves delicious burgers, smash fries, and shakes. They also highlight the friendly staff, fast service, and clean atmosphere.\n\nOther reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d7913-3310-728e-b8c4-82259b98b0f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-3310-728e-b8c4-82259b98b0f7",
        "storage_key": "property/6767906449165634/019d7913-3310-728e-b8c4-82259b98b0f7.webp",
        "width": 640,
        "height": 564
      },
      "poi_business_url": "https://smashburger.com/locations/us/ok/tulsa/10830-e-71st-st?utm_medium=organic&utm_source=local&utm_campaign=googlelistings&utm_content=website&utm_term=1039",
      "poi_directions_map_url": "https://maps.google.com/?cid=4819555078938426618&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "smashburger",
      "poi_latitude": "36.0603574",
      "poi_longitude": "-95.855566",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-307-0380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-e830-724a-a2d0-b6b2e75e4f4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-e830-724a-a2d0-b6b2e75e4f4d",
        "storage_key": "property/6767906449165634/019cfb49-e830-724a-a2d0-b6b2e75e4f4d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrXIbVbONtocR-vyNJ89_4kI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_2e9ad47b-b803-43d6-909d-2ff47d0ade95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Asahi Sushi Bar",
      "poi_type": "Restaurants",
      "poi_address": "7831 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Cozy, unassuming Japanese restaurant serving a variety of sushi & bento boxes at dinner.",
      "poi_long_description": "People say this sushi restaurant serves delicious sushi, including the lobster roll, tiger roll, and creamy shrimp appetizer. They highlight the fresh fish, tasty rolls, and reasonable prices. They also like the tranquil and traditional ambiance, and the attentive and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d7913-36ab-77b4-bf16-70ff9dd0b1d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-36ab-77b4-bf16-70ff9dd0b1d1",
        "storage_key": "property/6767906449165634/019d7913-36ab-77b4-bf16-70ff9dd0b1d1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16051105996929304904&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "asahi-sushi-bar",
      "poi_latitude": "36.0631558",
      "poi_longitude": "-95.8894562",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-307-9151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-e830-724a-a2d0-b6b2e75e4f4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-e830-724a-a2d0-b6b2e75e4f4d",
        "storage_key": "property/6767906449165634/019cfb49-e830-724a-a2d0-b6b2e75e4f4d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP9DDOo6NtocRSAkdn9z7wN4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_abdbc678-ffb7-4a45-b1a2-a668b442930a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "10711 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a great selection of products and easy returns. They also highlight the quick and efficient service provided by the SFS and drive-up crew, and the helpfulness of some employees.\n\nOther reviews mention the self-checkout can be unavailable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d7913-3941-7509-815a-c16e41788c32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-3941-7509-815a-c16e41788c32",
        "storage_key": "property/6767906449165634/019d7913-3941-7509-815a-c16e41788c32.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.target.com/sl/tulsa-se/1782",
      "poi_directions_map_url": "https://maps.google.com/?cid=11072252321475274749&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "36.0628683",
      "poi_longitude": "-95.8567584",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-307-8161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-e842-7258-b7bd-69f475edfe5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-e842-7258-b7bd-69f475edfe5c",
        "storage_key": "property/6767906449165634/019cfb49-e842-7258-b7bd-69f475edfe5c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ67yjULONtocR_ScHtdKKqJk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_2717c1d9-51e4-439c-89b2-7fea55b061cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "11011 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "Shoppers say this department store offers a wide selection of products, great sales, and good prices. They also highlight the friendly and helpful staff, and the clean and organized store.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d7913-3b0c-7351-833d-d7298f60c4e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-3b0c-7351-833d-d7298f60c4e3",
        "storage_key": "property/6767906449165634/019d7913-3b0c-7351-833d-d7298f60c4e3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kohls.com/stores/ok/tulsa-425.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=10465943342793208862&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kohl-s",
      "poi_latitude": "36.0629677",
      "poi_longitude": "-95.8533535",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-461-1950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-e842-7258-b7bd-69f475edfe5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-e842-7258-b7bd-69f475edfe5c",
        "storage_key": "property/6767906449165634/019cfb49-e842-7258-b7bd-69f475edfe5c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJwxxHW0yMtocRHrSN8gSAPpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_da7c8520-6690-45de-ab8b-6d8564b0e980",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "10303 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "People say this electronics store offers a wide variety of products, including TVs, laptops, and appliances. They also highlight the knowledgeable and helpful staff, and the convenient online ordering and pick-up service.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d7913-3b0b-72f2-81c4-903d6ea92f89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-3b0b-72f2-81c4-903d6ea92f89",
        "storage_key": "property/6767906449165634/019d7913-3b0b-72f2-81c4-903d6ea92f89.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://stores.bestbuy.com/ok/tulsa/10303-e-71st-st-221.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=2994601933184998961&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "36.064164",
      "poi_longitude": "-95.86075",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-250-6819",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-e842-7258-b7bd-69f475edfe5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-e842-7258-b7bd-69f475edfe5c",
        "storage_key": "property/6767906449165634/019cfb49-e842-7258-b7bd-69f475edfe5c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5SOWULGNtocRMZ4wl5f2jik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "custom_d00dc473-c699-4492-9fa7-5ba42fab812e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Shoe Carnival",
      "poi_type": "Shopping & Retail",
      "poi_address": "11007 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain store selling a wide array of brand-name footwear for men, women & kids.",
      "poi_long_description": "People say this shoe store offers a wide variety of shoes, boots, and sneakers at great prices. They also highlight the friendly and helpful staff.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d7913-4470-7168-994e-587c62036197.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-4470-7168-994e-587c62036197",
        "storage_key": "property/6767906449165634/019d7913-4470-7168-994e-587c62036197.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.shoecarnival.com/ok/tulsa/shoe-store-tulsa-ok-215.html?utm_source=google&utm_medium=listing&utm_content=215&utm_campaign=OK&utm_keyword=Tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=14005215760781730939&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "shoe-carnival",
      "poi_latitude": "36.0628711",
      "poi_longitude": "-95.8543514",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-249-0390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-e842-7258-b7bd-69f475edfe5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-e842-7258-b7bd-69f475edfe5c",
        "storage_key": "property/6767906449165634/019cfb49-e842-7258-b7bd-69f475edfe5c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJObNynEyMtocRe-QYGIiFXMI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shoe_store"
    },
    {
      "id": "custom_074120cd-2ee0-4587-ac3c-85061e4041a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Academy Sports + Outdoors",
      "poi_type": "Shopping & Retail",
      "poi_address": "7850 S 107th E Ave, Tulsa, OK 74133, USA",
      "poi_short_description": "Sporting goods chain selling athletic apparel & footwear, plus outdoor gear & fitness equipment.",
      "poi_long_description": "Shoppers say this sporting goods store offers a wide selection of shoes, camping equipment, and fishing gear, with great deals and fair prices. They also highlight the friendly and helpful staff, and the clean and well-organized store.\n\nSome reviews mention the online shopping experience can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d7913-48ec-750f-98e6-e18becdba366.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-48ec-750f-98e6-e18becdba366",
        "storage_key": "property/6767906449165634/019d7913-48ec-750f-98e6-e18becdba366.webp",
        "width": 1137,
        "height": 640
      },
      "poi_business_url": "https://www.academy.com/storelocator/oklahoma/tulsa/store-0084",
      "poi_directions_map_url": "https://maps.google.com/?cid=13160923161417580787&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "academy-sports-outdoors",
      "poi_latitude": "36.0493635",
      "poi_longitude": "-95.8561662",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-249-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-e842-7258-b7bd-69f475edfe5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-e842-7258-b7bd-69f475edfe5c",
        "storage_key": "property/6767906449165634/019cfb49-e842-7258-b7bd-69f475edfe5c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ47lbY8uNtocR84CBwOL9pLY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_c37e4bda-f501-41c7-8edb-4961de12a65d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "8221 E 61st St S, Tulsa, OK 74133, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "People say this supermarket offers a wide selection of products, including fresh produce and unique finds. They highlight the excellent prices and the friendly, helpful staff. They also like the clean and well-organized store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d7913-4c53-74e6-9506-468a3b950d2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-4c53-74e6-9506-468a3b950d2a",
        "storage_key": "property/6767906449165634/019d7913-4c53-74e6-9506-468a3b950d2a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ok/tulsa/8221-e-61st-street-suite-s/f270",
      "poi_directions_map_url": "https://maps.google.com/?cid=17856833842757364864&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "36.076668",
      "poi_longitude": "-95.885081",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-e837-7761-a708-df374575770c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-e837-7761-a708-df374575770c",
        "storage_key": "property/6767906449165634/019cfb49-e837-7761-a708-df374575770c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUWvnMXaNtocRgOy5OsU30Pc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_1d0ed138-0f55-44c5-9b92-0866aa59f97f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "6922 S Mingo Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "People say this warehouse club offers a wide selection of products and good prices. They also highlight the friendly staff and convenient bulk shopping.\n\nSome reviews mention the store can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d7913-4f2d-7039-af3a-5cba5d1345b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-4f2d-7039-af3a-5cba5d1345b6",
        "storage_key": "property/6767906449165634/019d7913-4f2d-7039-af3a-5cba5d1345b6.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://www.samsclub.com/club/6342-tulsa-ok",
      "poi_directions_map_url": "https://maps.google.com/?cid=2142616615335699436&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sam-s-club",
      "poi_latitude": "36.0628489",
      "poi_longitude": "-95.8716547",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-252-9503",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-e842-7258-b7bd-69f475edfe5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-e842-7258-b7bd-69f475edfe5c",
        "storage_key": "property/6767906449165634/019cfb49-e842-7258-b7bd-69f475edfe5c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOxq7n7uNtocR7CPvpnUavB0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_befb3de9-44c7-4733-aa26-abdfad200234",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Hobby Lobby",
      "poi_type": "Shopping & Retail",
      "poi_address": "9717 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain carrying a variety of arts & crafts materials, plus party supplies, fabric & home-decor items.",
      "poi_long_description": "People say this craft store offers a wide selection of products for hobbies and decorating, including yarn, fabric, and seasonal decorations. They highlight the good prices and the clean, organized store. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d7913-5112-71dd-a11b-a96db71c00db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-5112-71dd-a11b-a96db71c00db",
        "storage_key": "property/6767906449165634/019d7913-5112-71dd-a11b-a96db71c00db.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hobbylobby.com/stores/search/3",
      "poi_directions_map_url": "https://maps.google.com/?cid=5139651924585796964&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hobby-lobby",
      "poi_latitude": "36.0639533",
      "poi_longitude": "-95.8669013",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-254-0290",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-e842-7258-b7bd-69f475edfe5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-e842-7258-b7bd-69f475edfe5c",
        "storage_key": "property/6767906449165634/019cfb49-e842-7258-b7bd-69f475edfe5c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVS6DnLqNtocRZNUWwjG2U0c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_84a70d1f-cd0e-4125-b2dc-da96d5438ead",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Oklahoma Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "300 Aquarium Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Thousands of aquatic species, plus a walk-through tunnel & chances to touch sharks & stingrays.",
      "poi_long_description": "People say this aquarium offers a wide variety of aquatic creatures, including sharks, sea turtles, and jellyfish, as well as some land animals. They highlight the interactive experiences, such as touch tanks and feeding opportunities, and the well-maintained exhibits. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d7913-52a8-718d-b6ce-e8db6145bacd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-52a8-718d-b6ce-e8db6145bacd",
        "storage_key": "property/6767906449165634/019d7913-52a8-718d-b6ce-e8db6145bacd.webp",
        "width": 1280,
        "height": 878
      },
      "poi_business_url": "http://www.okaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13127406968110887214&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-aquarium",
      "poi_latitude": "36.0198841",
      "poi_longitude": "-95.9570456",
      "poi_miles_from_property": "9.1 mi",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-296-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-e830-724a-a2d0-b1d1679fe302.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-e830-724a-a2d0-b1d1679fe302",
        "storage_key": "property/6767906449165634/019cfb49-e830-724a-a2d0-b1d1679fe302.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOcElRmSRtocRLrE85BXrLbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_44f008d2-1b4e-4cd4-848e-224e02952b78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Philbrook Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "2727 S Rockford Rd, Tulsa, OK 74114, USA",
      "poi_short_description": "Global collection of fine & decorative art in an ornate Italian Renaissance-style mansion & gardens.",
      "poi_long_description": "People say this museum offers a diverse collection of art, including traditional and modern pieces, and a beautiful Samurai exhibit. They highlight the stunning architecture, the well-maintained gardens and grounds, and the serene views. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d7913-617b-75b1-8fdd-0652ac7a13ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-617b-75b1-8fdd-0652ac7a13ed",
        "storage_key": "property/6767906449165634/019d7913-617b-75b1-8fdd-0652ac7a13ed.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.philbrook.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1301074669923315730&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "philbrook-museum-of-art",
      "poi_latitude": "36.1238549",
      "poi_longitude": "-95.9700944",
      "poi_miles_from_property": "9.8 mi",
      "poi_walking_minutes": "3 hours 38 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-749-7941",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d7913-7470-7141-963d-753130068ec1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-7470-7141-963d-753130068ec1",
        "storage_key": "property/6767906449165634/019d7913-7470-7141-963d-753130068ec1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0VsvX7DstocRErAJ14RYDhI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_ae06a63f-88ec-406f-b6d4-8668a8d25dff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "River Spirit Casino Resort",
      "poi_type": "Entertainment",
      "poi_address": "8330 Riverside Pkwy, Tulsa, OK 74137, USA",
      "poi_short_description": "Riverside casino offering a steakhouse, casual eateries, table & electronic gaming, & weekend shows.",
      "poi_long_description": "People say this casino offers a wide variety of slot machines, live music, and entertainment venues, including a concert venue and a sports bar. They also highlight the clean and spacious rooms with beautiful views, the friendly and helpful staff, and the convenient amenities such as free valet parking and keyless check-in.\n\nOther reviews mention the machines can be tight.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d7913-5bec-7761-88de-b38dc85d7e7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-5bec-7761-88de-b38dc85d7e7e",
        "storage_key": "property/6767906449165634/019d7913-5bec-7761-88de-b38dc85d7e7e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.riverspirittulsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12292203165626239741&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "river-spirit-casino-resort",
      "poi_latitude": "36.0419162",
      "poi_longitude": "-95.9638914",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 888-748-3731",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-e830-724a-a2d0-b1d1679fe302.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-e830-724a-a2d0-b1d1679fe302",
        "storage_key": "property/6767906449165634/019cfb49-e830-724a-a2d0-b1d1679fe302.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJscNp2cGTtocR_YoV-qatlqo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "casino"
    },
    {
      "id": "custom_f2881cf3-bf6c-42e8-bc76-6b633999b6d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Tulsa Zoo",
      "poi_type": "Entertainment",
      "poi_address": "6421 E 36th St N, Tulsa, OK 74115, USA",
      "poi_short_description": "An expansive, educational park with a huge variety of animals, plus the Safari Train & a carousel.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including elephants, sea lions, and tigers, and has a dinosaur exhibit, carousel, and playground. They highlight the membership is worth it, especially for large groups, and the zoo is family-friendly. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d7913-5d2d-767a-bfff-5f3a5558bdbc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-5d2d-767a-bfff-5f3a5558bdbc",
        "storage_key": "property/6767906449165634/019d7913-5d2d-767a-bfff-5f3a5558bdbc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.tulsazoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10038979359347895889&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-zoo",
      "poi_latitude": "36.2130153",
      "poi_longitude": "-95.9064904",
      "poi_miles_from_property": "12.7 mi",
      "poi_walking_minutes": "4 hours 41 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-669-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-e830-724a-a2d0-b1d1679fe302.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-e830-724a-a2d0-b1d1679fe302",
        "storage_key": "property/6767906449165634/019cfb49-e830-724a-a2d0-b1d1679fe302.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjb_PwwXutocRUe5o3YmeUYs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_5b53c536-d124-418b-9304-c528af0ed6f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Gathering Place",
      "poi_type": "Entertainment",
      "poi_address": "2650 S John Williams Way, Tulsa, OK 74114, USA",
      "poi_short_description": "Riverfront park featuring an adventure playground, a sensory garden, a picnic area, eateries & more.",
      "poi_long_description": "People say this park offers a wide variety of activities, including playgrounds, water features, walking trails, and opportunities to feed fish. They highlight the beautiful, well-maintained grounds, the fun and interactive experiences for families, and the ample parking. They also like the availability of restrooms, food, and drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019d7913-629f-716c-8deb-700b6c945dd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-629f-716c-8deb-700b6c945dd2",
        "storage_key": "property/6767906449165634/019d7913-629f-716c-8deb-700b6c945dd2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gatheringplace.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14222367875341211287&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "gathering-place",
      "poi_latitude": "36.1251603",
      "poi_longitude": "-95.9840207",
      "poi_miles_from_property": "10.6 mi",
      "poi_walking_minutes": "3 hours 56 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-779-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-e832-7200-a40d-941222636149.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-e832-7200-a40d-941222636149",
        "storage_key": "property/6767906449165634/019cfb49-e832-7200-a40d-941222636149.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJrYnn1dDttocRl9ajsjoAYMU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_77ddaebe-f4e5-4d53-bc95-d5755b2fc925",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Regent Preparatory School (grades pre-K through 12)",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "regent-preparatory-school-grades-pre-k-through-12",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_602d9771-f20b-4dab-999c-c3979d9795b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "poi_name": "Holland Hall (grades pre-K through 12)",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "holland-hall-grades-pre-k-through-12",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_e356f87c08a48543bea9ef67",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_092ed229b6037412d3fad05a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_a45c6e5ff7179646172dad2f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_4cdc5b3f4709d91161d21a16",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_cc49bc5c12f38f8731354fdb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_259fb6f4bf2d87d12ac1aef1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_53184ed9989fd681d6c84090",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "day": "SUN",
      "open_time": "13:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_6817ecb9-c68a-455e-a293-32bab8d71149",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "rating": "5.0",
      "name": "Mindy",
      "text": "Greens Of Bedford is a wonderful place to live at. The management to the leasing agents are very professional and knowledgeable. If you have anything wrong with your apartment they are on top of it. Alex has always been so kind and helpful with questions to fixing things in my apartment. They keep the grounds well maintained and the maintenance guys are extremely knowledgeable and fix things fast. I only had one main issue here, but like I said management and Alex were on top of it and it was resolved. I highly recommend Greens of Bedford if you’re looking for an apartment. You won’t be disappointed!",
      "date": "2025-09-08",
      "title": ""
    },
    {
      "id": "custom_3f938978-ddc8-44f3-b20c-3e2b510821ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "rating": "5.0",
      "name": "Cyrilla Stewart",
      "text": "Excellent proficient staff. Very customer oriented. Swift problem solving maintenace staff. Any requests always taken care of quickly. A great place to live!",
      "date": "2025-08-19",
      "title": ""
    },
    {
      "id": "custom_de42b595-bbf7-484c-a8b0-6d0ff4c75aca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "rating": "5.0",
      "name": "Griz Lorenzo",
      "text": "We love this place, the service on the maintnance is excelente, the whole team is so eficient. They take care so fast on our needs! Thank you!",
      "date": "2025-10-11",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_65944378-0b71-4360-be14-edb3066326c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb4a-69f1-729f-a3c3-d39e80e57380.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of a kitchen and living area with a bar and stools",
        "public_id": "019cfb4a-69f1-729f-a3c3-d39e80e57380",
        "storage_key": "property/6767906449165634/019cfb4a-69f1-729f-a3c3-d39e80e57380.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Greens of Bedford Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=5f6d5f38ee5aba0c3b8beaab"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-6dbc-7539-aef9-cadaf9eb7564",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "the-greens-of-bedford",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634"
    },
    {
      "lead_collector_id": "019cf79e-6e30-74b9-977d-f5d1eb817486",
      "lead_source": "LANDING_PAGE",
      "name": "the-greens-of-bedford",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-pool-tulsa-ok-greens-of-bedford",
      "search_query": "luxury apartments with pool Tulsa OK",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Tulsa, OK",
      "h2_subtitle": "Discover luxury living at The Greens of Bedford. Our Tulsa, OK apartments feature a refreshing pool and sophisticated amenities.",
      "page_copy": "At The Greens of Bedford, we offer luxury apartments with pool in Tulsa, OK that combine upscale living with everyday comfort. Our community showcases a stunning pool, perfect for relaxation or a refreshing swim on a warm Oklahoma day. Located in the vibrant South Tulsa neighborhood, residents enjoy not only the pool but also modern amenities like a state-of-the-art fitness center and serene walking trails.\n\nOur thoughtfully designed one, two, and three-bedroom apartments ensure there is a perfect home that meets your needs. Each unit comes with high-speed internet access, efficient heating, and modern conveniences like a microwave and elegant window coverings. Come experience Tulsa luxury living; visit us today and enjoy the lifestyle you deserve!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-c688-70db-9ab1-c0679196c3de.webp",
      "featured_image_media": {
        "alt_text": "Signage for The Greens of Bedford apartment complex with brick building exterior and landscaping.",
        "public_id": "019cfb49-c688-70db-9ab1-c0679196c3de",
        "storage_key": "property/6767906449165634/019cfb49-c688-70db-9ab1-c0679196c3de.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Tulsa, OK",
      "seo_description": "Explore luxury apartments with a pool in Tulsa, OK at The Greens of Bedford. Enjoy top-notch amenities and exceptional comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-near-south-tulsa-greens-bedford",
      "search_query": "air conditioned apartments near South Tulsa",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments Near South Tulsa",
      "h2_subtitle": "Experience comfort in our air conditioned apartments near South Tulsa. Enjoy modern amenities and a convenient location at The Greens of Bedford.",
      "page_copy": "Escape the heat and find tranquility in our air conditioned apartments near South Tulsa at The Greens of Bedford. Our community offers a serene living environment with all the comforts you need, including efficient air conditioning in each unit. Nestled in a desirable neighborhood, our residences boast a combination of luxury and practicality with access to a range of modern amenities such as a high-speed internet, a fully equipped fitness center, and inviting dining spaces.\n\nDesigned with you in mind, our one, two, and three-bedroom apartments provide spacious layouts equipped with every feature necessary for a comfortable lifestyle. Whether you are relaxing under the cool air conditioning or exploring our refreshing pool and walking trails, The Greens of Bedford is where luxury meets convenience. Schedule a tour today and experience the ultimate comfort of our air conditioned homes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-c688-70db-9ab1-c0679196c3de.webp",
      "featured_image_media": {
        "alt_text": "Signage for The Greens of Bedford apartment complex with brick building exterior and landscaping.",
        "public_id": "019cfb49-c688-70db-9ab1-c0679196c3de",
        "storage_key": "property/6767906449165634/019cfb49-c688-70db-9ab1-c0679196c3de.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments Near South Tulsa",
      "seo_description": "Discover air conditioned apartments near South Tulsa at The Greens of Bedford. Enjoy spacious layouts and comfortable living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "generator",
      "page_item_url": "apartments-with-dog-park-tulsa-74133-greens-bedford",
      "search_query": "apartments with dog park Tulsa 74133",
      "category": "Amenity",
      "h1_title": "Apartments with Dog Park in Tulsa, 74133",
      "h2_subtitle": "Find perfect pet-friendly living at The Greens of Bedford. Our Tulsa, 74133 apartments offer a welcoming dog park for your furry friends.",
      "page_copy": "At The Greens of Bedford, we understand that pets are family, which is why we offer apartments with a dog park right here in Tulsa, 74133. Our community is not only perfect for you but also for your furry companions. Enjoy a dedicated dog park where your pets can play and socialize while you enjoy the luxury amenities we provide.\n\nLocated in the vibrant South Tulsa area, our one, two, and three-bedroom apartments are designed with both comfort and convenience in mind. Along with a refreshing pool, fitness center, and serene walking trails, our pet-friendly community ensures a welcoming atmosphere for everyone. Whether you're relaxing at home or exploring our outdoor spaces with your pet, The Greens of Bedford is the ideal choice for balanced living. Visit us today and see why our community is the perfect home for you and your pets.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-c688-70db-9ab1-c0679196c3de.webp",
      "featured_image_media": {
        "alt_text": "Signage for The Greens of Bedford apartment complex with brick building exterior and landscaping.",
        "public_id": "019cfb49-c688-70db-9ab1-c0679196c3de",
        "storage_key": "property/6767906449165634/019cfb49-c688-70db-9ab1-c0679196c3de.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dog Park in Tulsa, 74133",
      "seo_description": "Discover pet-friendly living at The Greens of Bedford, with a dog park right in Tulsa, 74133. Enjoy luxury amenities for you and your furry friends.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "generator",
      "page_item_url": "fitness-center-apartment-community-tulsa-greens-bedford",
      "search_query": "fitness center apartment community Tulsa",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartment Community Tulsa",
      "h2_subtitle": "Stay fit and active at The Greens of Bedford. Our Tulsa apartment community features a state-of-the-art fitness center.",
      "page_copy": "Discover the perfect blend of luxury and fitness at The Greens of Bedford, a premier apartment community in Tulsa. Our state-of-the-art fitness center is designed to cater to all your workout needs, ensuring you can maintain a healthy lifestyle without leaving home. Located in the desirable South Tulsa neighborhood, our community offers a host of other modern amenities, including a refreshing pool and serene walking trails for post-workout relaxation.\n\nOur spacious one, two, and three-bedroom apartments are equipped to provide the utmost comfort, featuring high-speed internet, elegant window coverings, and contemporary kitchen appliances. At The Greens of Bedford, we prioritize your lifestyle and wellness, making it easy for you to enjoy all the benefits of a fitness-focused living environment. Come take a tour and see how our Tulsa apartment community can become your active haven.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-c688-70db-9ab1-c0679196c3de.webp",
      "featured_image_media": {
        "alt_text": "Signage for The Greens of Bedford apartment complex with brick building exterior and landscaping.",
        "public_id": "019cfb49-c688-70db-9ab1-c0679196c3de",
        "storage_key": "property/6767906449165634/019cfb49-c688-70db-9ab1-c0679196c3de.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartment Community Tulsa",
      "seo_description": "Enjoy a fitness-focused lifestyle at The Greens of Bedford. Our Tulsa apartment community features a modern fitness center and luxury amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-near-south-tulsa-greens-bedford",
      "search_query": "in-unit laundry apartments near South Tulsa",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments Near South Tulsa",
      "h2_subtitle": "Enjoy the convenience of in-unit laundry at The Greens of Bedford, located near South Tulsa. Experience a hassle-free lifestyle today.",
      "page_copy": "Simplify your daily routine with the convenience of in-unit laundry at The Greens of Bedford, located near South Tulsa. Our thoughtfully designed one, two, and three-bedroom apartments offer modern amenities that cater to your lifestyle needs, ensuring comfort and functionality. Experience the liberation of doing laundry at your convenience, without having to leave your apartment.\n\nBeyond in-unit laundry, our community provides an array of additional features, including a sparkling pool, state-of-the-art fitness center, and peaceful walking trails to enhance your living experience. Nestled in the desirable South Tulsa area, The Greens of Bedford combines practicality with luxury, creating a perfect environment for you to call home. Come and visit us today to explore our amenities and find your ideal living space.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-c688-70db-9ab1-c0679196c3de.webp",
      "featured_image_media": {
        "alt_text": "Signage for The Greens of Bedford apartment complex with brick building exterior and landscaping.",
        "public_id": "019cfb49-c688-70db-9ab1-c0679196c3de",
        "storage_key": "property/6767906449165634/019cfb49-c688-70db-9ab1-c0679196c3de.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments Near South Tulsa",
      "seo_description": "Discover hassle-free living with in-unit laundry at The Greens of Bedford near South Tulsa. Enjoy modern amenities and comfort in one place.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-south-tulsa-greens-bedford",
      "search_query": "1 bedroom apartments south tulsa",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in South Tulsa",
      "h2_subtitle": "Discover stylish one-bedroom apartments at The Greens of Bedford in South Tulsa, perfectly designed for modern living.",
      "page_copy": "Experience the perfect blend of style and comfort in our 1 bedroom apartments at The Greens of Bedford, situated in the heart of South Tulsa. These thoughtfully designed units offer ample space and modern amenities, providing an ideal setting for contemporary living. Enjoy high-speed internet access, elegant window coverings, and a well-appointed kitchen with a microwave, making daily life both comfortable and convenient.\n\nLocated in South Tulsa, our community promises more than just beautiful apartments. Immerse yourself in the vibrant surroundings with access to our state-of-the-art fitness center, refreshing pool, and serene walking trails—perfect for both relaxation and recreation. At The Greens of Bedford, luxury meets practicality, offering a welcoming home that caters to your every need. Visit us today to explore our one-bedroom options and discover why our community is a top choice in South Tulsa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-c688-70db-9ab1-c0679196c3de.webp",
      "featured_image_media": {
        "alt_text": "Signage for The Greens of Bedford apartment complex with brick building exterior and landscaping.",
        "public_id": "019cfb49-c688-70db-9ab1-c0679196c3de",
        "storage_key": "property/6767906449165634/019cfb49-c688-70db-9ab1-c0679196c3de.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in South Tulsa",
      "seo_description": "Find stylish 1 bedroom apartments at The Greens of Bedford in South Tulsa. Enjoy modern amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "generator",
      "page_item_url": "2-bedroom-luxury-apartments-tulsa-ok-greens-bedford",
      "search_query": "2 bedroom luxury apartments in tulsa ok",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Luxury Apartments in Tulsa, OK",
      "h2_subtitle": "Explore our elegant two-bedroom luxury apartments at The Greens of Bedford, perfectly set in Tulsa, OK. Unmatched amenities await you.",
      "page_copy": "Indulge in the elegance of our 2 bedroom luxury apartments at The Greens of Bedford, located in the vibrant city of Tulsa, OK. Our spacious and thoughtfully designed units promise comfort and sophistication, complete with modern appliances and finishes. Each apartment features high-speed internet access, stylish window coverings, and a dining room, ensuring you have everything you need for a relaxed lifestyle.\n\nBeyond the luxury of your own home, our Tulsa community offers a host of amenities that elevate everyday living. Enjoy access to a state-of-the-art fitness center, a stunning pool, and inviting walking trails, all designed to enhance your leisure time. Nestled in the desirable South Tulsa neighborhood, The Greens of Bedford combines convenience with upscale living. Discover why our two-bedroom offerings are the perfect choice for those seeking luxury in Tulsa, OK. Schedule a tour with us to see your future home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-c688-70db-9ab1-c0679196c3de.webp",
      "featured_image_media": {
        "alt_text": "Signage for The Greens of Bedford apartment complex with brick building exterior and landscaping.",
        "public_id": "019cfb49-c688-70db-9ab1-c0679196c3de",
        "storage_key": "property/6767906449165634/019cfb49-c688-70db-9ab1-c0679196c3de.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Luxury Apartments in Tulsa, OK",
      "seo_description": "Discover 2 bedroom luxury living at The Greens of Bedford in Tulsa, OK. Enjoy top-notch amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165634",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-near-74133-greens-bedford",
      "search_query": "3 bedroom apartments near 74133",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments Near 74133",
      "h2_subtitle": "Find spacious three-bedroom apartments at The Greens of Bedford, close to the 74133 area in Tulsa. Ideal for families and shared living.",
      "page_copy": "Discover the perfect home at The Greens of Bedford with our spacious 3 bedroom apartments, conveniently located near the 74133 ZIP code in Tulsa. These generously sized residences are perfect for families or those needing extra space, offering a blend of style and practicality. Each unit features high-speed internet access, heating, and fully equipped kitchens with microwaves to enhance your daily living experience.\n\nOur community is more than just well-designed apartments. Located in the sought-after area of South Tulsa, residents enjoy exclusive access to a variety of amenities including a refreshing pool, a cutting-edge fitness center, and serene walking trails. Whether you're hosting a meal in your dining room or exploring the vibrant local area, The Greens of Bedford offers a welcoming environment catering to all your living needs. Visit us to see why our three-bedroom apartments are the perfect choice near the 74133 area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-c688-70db-9ab1-c0679196c3de.webp",
      "featured_image_media": {
        "alt_text": "Signage for The Greens of Bedford apartment complex with brick building exterior and landscaping.",
        "public_id": "019cfb49-c688-70db-9ab1-c0679196c3de",
        "storage_key": "property/6767906449165634/019cfb49-c688-70db-9ab1-c0679196c3de.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments Near 74133",
      "seo_description": "Explore 3 bedroom apartments at The Greens of Bedford near 74133 in Tulsa. Spacious living with modern amenities awaits you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5176"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-2B9E58HPJ2"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151867"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/greens-of-bedford/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PVBXS6ZM"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6767906449165634/019f61b5-0da1-74df-9742-1fb4262e338e.webp"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "493265f0-c1ac-40f1-8017-18018f9b7916"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-982-3561"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "64418530f6000a65260a76da"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImxLME5VK1FUMUZyT1NHU3Z3anBDcHc9PSIsInZhbHVlIjoiV3JDcXZ6QmZWcnBVbmVuTkY3NmIydz09IiwibWFjIjoiNTE0ZjNjYzMxNTA4ZTA1YzA0ZjMxYmFlOWQyNzZiMjQ5MGU3NzY5NDU3NmQ3ODYxYTkwYTc0YzY5MjlhNTllMiJ9"
    }
  ],
  "custom_qb_id": "5176",
  "custom_ga4_id": "G-2B9E58HPJ2",
  "custom_repli_id": "10041151867",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/greens-of-bedford/register/",
  "custom_google_gtm_id": "GTM-PVBXS6ZM",
  "custom_floorplan_pdf_url": "https://media.multihub.io/property/6767906449165634/019f61b5-0da1-74df-9742-1fb4262e338e.webp",
  "custom_rentgrata_property_id": "493265f0-c1ac-40f1-8017-18018f9b7916",
  "custom_ppc_tracking_phone_number": "844-982-3561",
  "custom_residentboost_apartment_id": "64418530f6000a65260a76da",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImxLME5VK1FUMUZyT1NHU3Z3anBDcHc9PSIsInZhbHVlIjoiV3JDcXZ6QmZWcnBVbmVuTkY3NmIydz09IiwibWFjIjoiNTE0ZjNjYzMxNTA4ZTA1YzA0ZjMxYmFlOWQyNzZiMjQ5MGU3NzY5NDU3NmQ3ODYxYTkwYTc0YzY5MjlhNTllMiJ9"
};

export const generatedAt = '2026-08-27T21:35:41.819Z';
